import React, { useState, useEffect, useCallback, useRef } from 'react';
import "@/App.css";
import "@/styles/mobile-responsive.css"; // 📱 Overrides mobile non-invasifs
import { Toaster } from './components/ui/sonner';
import { toast } from 'sonner';
import { ticketService } from './services/api';
import api from './services/api';
import { StatsCards } from './components/dashboard/StatsCards';
import { TicketTable } from './components/tickets/TicketTable';
import RecapAchat from './components/tickets/RecapAchat';
import { EmailImportModal } from './components/tickets/EmailImportModal';
import { TicketFormModal } from './components/tickets/TicketFormModal';
// SplitAchatModal removed per user request
import BulkSeatUpdateModal from './components/modals/BulkSeatUpdateModal';
import { BulkImportModal } from './components/tickets/BulkImportModal';
import { SmartImportModal } from './components/tickets/SmartImportModal';
import { GoogleSheetsImportModal } from './components/modals/GoogleSheetsImportModal';
import { InboxModal } from './components/email/InboxModal';
import { DoublonsModal } from './components/tickets/DoublonsModal';
import { EmailUpdateModal } from './components/tickets/EmailUpdateModal';
import { AntiSingleModal } from './components/tickets/AntiSingleModal';
import { AttribuerVenteModal } from './components/tickets/AttribuerVenteModal';
import { SpecialAttributionModal } from './components/tickets/SpecialAttributionModal';
import { RefCheckModal } from './components/tickets/RefCheckModal';
import { MajClientsModal } from './components/tickets/MajClientsModal';
import { NormalizationModal } from './components/modals/NormalizationModal';
import { AiMatchModal } from './components/modals/AiMatchModal';
import { AiAssistantWidget } from './components/modals/AiAssistantWidget';
import { SourcePhonesModal } from './components/modals/SourcePhonesModal';
import { DuplicateWarningModal } from './components/modals/DuplicateWarningModal';
import { ProofUploadModal } from './components/tickets/ProofUploadModal';
import { ProofEnvoiModal } from './components/tickets/ProofEnvoiModal';
import { BulkValidateModal } from './components/modals/BulkValidateModal';
import { AuditLivraisonsModal } from './components/modals/AuditLivraisonsModal';
import { UpdatePlacementModal } from './components/modals/UpdatePlacementModal';
import { applyCustomPlans } from './data/stadiums';
import AideListingView from './components/tickets/AideListingView';
import AuditQuotaView from './components/tickets/AuditQuotaView';
import PartialAttributionsView from './components/tickets/PartialAttributionsView';
import StadiumPlanModal from './components/tickets/StadiumPlanModal';
import FloatingPlanWindow from './components/tickets/FloatingPlanWindow';
import { MatcherFilterModal } from './components/modals/MatcherFilterModal';
import ErrorBoundary from './components/ErrorBoundary';
import { LanguageSwitcher } from './components/LanguageSwitcher';
import { useLanguage } from './i18n/LanguageContext';
// ProofsView removed - feature disabled
import { DeltaView } from './components/dashboard/DeltaView';
import { GroupsView } from './components/dashboard/GroupsView';
import FinalBracketView from './components/dashboard/FinalBracketView';
import { wc26Service } from './services/api';
import { setResolvedTeams, setMatchLookup } from './utils/resolveEventName';
import { LogView } from './components/dashboard/LogView';
import { StadiumMappingView } from './components/dashboard/StadiumMappingView';
import { BackupsView } from './components/dashboard/BackupsView';
import { MarketEvolutionView } from './components/dashboard/MarketEvolutionView';
import { WorldCupGroupsView } from './components/dashboard/WorldCupGroupsView';
import { RGMatchesView } from './components/dashboard/RGMatchesView';
import AccountsView from './components/tickets/AccountsView';
import SystemHealthModal from './components/admin/SystemHealthModal';
import { LoginPage } from './components/auth/LoginPage';
import { Button } from './components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './components/ui/tabs';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from './components/ui/dropdown-menu';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from './components/ui/sheet';
import { 
  ShoppingCart, 
  TrendingUp, 
  BarChart3, 
  FileText,
  Mail,
  Plus,
  RefreshCw,
  Zap,
  FileSpreadsheet,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  LayoutGrid,
  Inbox,
  LogOut,
  Download,
  AlertTriangle,
  AlertCircle,
  ArrowRight,
  Play,
  Pause,
  Clock,
  Settings,
  X,
  Filter,
  History,
  RotateCcw,
  User,
  Search,
  Sun,
  Moon,
  Bug,
  CheckCircle,
  Trash2,
  Archive,
  Users,
  Menu,
  Phone,
  Link2,
  Ticket,
  Bell,
  Scissors,
  MapPin,
  ShieldAlert,
  Activity,
  Wrench
} from 'lucide-react';

// 🎨 Couleur distinctive par projet (séparation visuelle stricte)
const PROJECT_COLORS = {
  'WORLD CUP 2026': '#C4A052',
  'ROLAND GARROS': '#D35400',
  'FFR': '#3B82F6',
  'PSG': '#E30613',
};
const getProjectColor = (name) => {
  if (!name) return '#C4A052';
  const key = name.toUpperCase();
  if (PROJECT_COLORS[key]) return PROJECT_COLORS[key];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
  return `hsl(${h}, 70%, 55%)`;
};

// Logo YAS - Grande taille (150px) avec effet hover
const YASLogo = () => (
  <img 
    src="https://customer-assets.emergentagent.com/job_billetterie-gmail/artifacts/yf5nvc9a_image.png" 
    alt="YAS"
    className="cursor-pointer transition-all duration-300 hover:scale-105"
    style={{ 
      height: '150px', 
      width: 'auto',
      filter: 'drop-shadow(0 0 20px rgba(196, 160, 82, 0.5))'
    }}
    onMouseEnter={(e) => e.target.style.filter = 'drop-shadow(0 0 40px rgba(196, 160, 82, 1)) drop-shadow(0 0 70px rgba(196, 160, 82, 0.8))'}
    onMouseLeave={(e) => e.target.style.filter = 'drop-shadow(0 0 20px rgba(196, 160, 82, 0.5))'}
  />
);

// Fonction utilitaire pour normaliser les accents (pour la recherche insensible aux accents)
const normalizeAccents = (str) => {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

import { usePresence } from './hooks/usePresence';

// Récap ACHAT toggle wrapper (Roland Garros)
function RecapAchatToggle({ tickets, project }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-3" data-testid="recap-achat-toggle">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-500/10 border border-amber-500/30 hover:bg-amber-500/20 transition-colors text-sm font-medium text-amber-400"
        data-testid="recap-achat-btn"
      >
        {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        RÉCAP STOCK ACHAT
      </button>
      {open && (
        <div className="mt-2 p-3 rounded-lg border border-zinc-700/50 bg-zinc-900/50">
          <RecapAchat tickets={tickets} project={project} />
        </div>
      )}
    </div>
  );
}

function App() {
  const { t } = useLanguage();
  
  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [userName, setUserName] = useState('');
  const [userPseudo, setUserPseudo] = useState('');
  const [authChecking, setAuthChecking] = useState(true);
  
  // Theme state (dark by default)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('yas_theme');
    return saved ? saved === 'dark' : true; // Default to dark
  });
  
  // Apply theme on change
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.remove('light-mode');
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
      document.documentElement.classList.add('light-mode');
    }
    localStorage.setItem('yas_theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  // WebSocket presence — connected via fetchData below

  // Check existing session on mount
  useEffect(() => {
    const token = localStorage.getItem('yas_token');
    const name = localStorage.getItem('yas_user');
    if (token) {
      // Verify token is still valid
      fetch(`/api/auth/verify?token=${token}`, {
        timeout: 10000 // 10 second timeout
      })
        .then(res => res.json())
        .then(data => {
          if (data.valid) {
            setIsAuthenticated(true);
            setAuthToken(token);
            setUserName(data.name || name);
            setUserPseudo(data.pseudo || localStorage.getItem('yas_pseudo') || data.name || name);
          } else if (data.reason === "Session expirée") {
            // Only logout if session is explicitly expired
            console.log("Session expirée, déconnexion");
            localStorage.removeItem('yas_token');
            localStorage.removeItem('yas_user');
          } else {
            // For any other reason (server restart, etc), keep user logged in
            // The session will be recreated on next login if needed
            console.log("Token non reconnu mais on garde la session locale");
            setIsAuthenticated(true);
            setAuthToken(token);
            setUserName(name || '');
          }
        })
        .catch((error) => {
          // If server error or network issue, KEEP user logged in
          console.log("Erreur vérification token, session locale maintenue:", error);
          setIsAuthenticated(true);
          setAuthToken(token);
          setUserName(name || '');
        })
        .finally(() => setAuthChecking(false));
    } else {
      setAuthChecking(false);
    }
  }, []);

  const handleLogin = (token, name, pseudo) => {
    setAuthToken(token);
    setUserName(name);
    setUserPseudo(pseudo || name);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('yas_token');
    localStorage.removeItem('yas_user');
    localStorage.removeItem('yas_pseudo');
    setIsAuthenticated(false);
    setAuthToken(null);
    setUserName('');
    setUserPseudo('');
  };

  // App state
  const [activeTab, setActiveTab] = useState('delta');
  const programmaticTabChange = useRef(false);
  
  // Tab change from KPI cards/Delta (preserve filters)
  const setActiveTabFromCard = (tab) => {
    programmaticTabChange.current = true;
    setActiveTab(tab);
  };
  const [tickets, setTickets] = useState([]);
  const [stats, setStats] = useState(null);
  const [delta, setDelta] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  // Progression chargement initial (0..100) — pour la barre de progression visuelle
  const [loadProgress, setLoadProgress] = useState(0);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);
  const [showSmartImportModal, setShowSmartImportModal] = useState(false);
  const [showMajClientsModal, setShowMajClientsModal] = useState(false);
  const [showNormalizationModal, setShowNormalizationModal] = useState(false);
  const [showAiMatchModal, setShowAiMatchModal] = useState(false);
  const [showGoogleSheetsModal, setShowGoogleSheetsModal] = useState(false);
  const [recapDeltaFilter, setRecapDeltaFilter] = useState(null); // Filtre depuis RECAP DELTA
  const [showInboxModal, setShowInboxModal] = useState(false);
  const [showDoublonsModal, setShowDoublonsModal] = useState(false);
  const [showEmailUpdateModal, setShowEmailUpdateModal] = useState(false);
  const [showBulkValidateModal, setShowBulkValidateModal] = useState(false);
  const [showAuditLivraisonsModal, setShowAuditLivraisonsModal] = useState(false);
  const [showUpdatePlacementModal, setShowUpdatePlacementModal] = useState(false);
  const [attribStadium, setAttribStadium] = useState(null);
  const [attribStadiumInfo, setAttribStadiumInfo] = useState(null);
  const [showProofModal, setShowProofModal] = useState(false);
  const [proofTicket, setProofTicket] = useState(null);
  const [showProofEnvoiModal, setShowProofEnvoiModal] = useState(false);
  const [proofEnvoiTicket, setProofEnvoiTicket] = useState(null);
  const [showAntiSingleModal, setShowAntiSingleModal] = useState(false);
  const [showAttribuerVenteModal, setShowAttribuerVenteModal] = useState(false);
  const [showSpecialAttributionModal, setShowSpecialAttributionModal] = useState(false);
  const [showRefCheckModal, setShowRefCheckModal] = useState(false);
  const [selectedVenteForAttribution, setSelectedVenteForAttribution] = useState(null);
  const [editingTicket, setEditingTicket] = useState(null);
  const [addedSources, setAddedSources] = useState([]);
  const [selectedAccountFilter, setSelectedAccountFilter] = useState(null); // Filtre par compte email
  const [statusFilter, setStatusFilter] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sourcePhones, setSourcePhones] = useState({});
  const [showSourcePhonesModal, setShowSourcePhonesModal] = useState(false);
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [showBulkSeatModal, setShowBulkSeatModal] = useState(false);
  
  // Projet courant - persisté dans localStorage
  const [currentProject, setCurrentProject] = useState(() => {
    const saved = localStorage.getItem('yas_current_project');
    return saved || 'WORLD CUP 2026';
  });
  const [showProjectMenu, setShowProjectMenu] = useState(false);
  const [headerCollapsed, setHeaderCollapsed] = useState(() => localStorage.getItem('yas_header_collapsed') !== '0');
  const toggleHeaderCollapsed = () => {
    setHeaderCollapsed((prev) => {
      localStorage.setItem('yas_header_collapsed', prev ? '0' : '1');
      return !prev;
    });
  };
  const [showProjectChangeConfirm, setShowProjectChangeConfirm] = useState(false);
  const [pendingProjectChange, setPendingProjectChange] = useState(null);
  
  // Sauvegarder le projet dans localStorage quand il change
  useEffect(() => {
    if (currentProject) {
      localStorage.setItem('yas_current_project', currentProject);
    }
  }, [currentProject]);

  // 🔒 Garde anti-mélange : si projet non-foot, quitter les onglets WC26
  useEffect(() => {
    const isFootWC = (currentProject?.toUpperCase() || '').startsWith('WORLD CUP');
    if (!isFootWC && ['groupes', 'phase-finale', 'groups'].includes(activeTab)) {
      setActiveTab('tout');
    }
  }, [currentProject, activeTab]);
  
  // Fonction pour changer de projet avec confirmation
  const requestProjectChange = (newProject) => {
    if (newProject === currentProject) {
      setShowProjectMenu(false);
      return;
    }
    setPendingProjectChange(newProject);
    setShowProjectChangeConfirm(true);
    setShowProjectMenu(false);
  };
  
  const confirmProjectChange = () => {
    if (pendingProjectChange) {
      setCurrentProject(pendingProjectChange);
      setPendingProjectChange(null);
    }
    setShowProjectChangeConfirm(false);
  };
  
  const cancelProjectChange = () => {
    setPendingProjectChange(null);
    setShowProjectChangeConfirm(false);
  };
  
  // Tickets filtrés par TicketTable (pour export avec filtres)
  const [tableFilteredTickets, setTableFilteredTickets] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);
  
  // Global search term - persists across tabs
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  
  // Delta filter state - for filtering from DELTA view
  const [deltaFilter, setDeltaFilter] = useState(null); // { matchNum, category, viewType, eventName }
  // Delta view mode - persists across navigation (cards/table)
  const [deltaViewMode, setDeltaViewMode] = useState('cards');

  // Quand le deltaFilter (RECAP DELTA) est activé, vider la barre de recherche
  useEffect(() => {
    if (deltaFilter) {
      // Toujours vider la barre de recherche quand deltaFilter est activé
      setGlobalSearchTerm('');
    }
  }, [deltaFilter]); // Ne dépend QUE de deltaFilter, pas de globalSearchTerm

  // Auto Matcher state
  const [autoMatcherEnabled, setAutoMatcherEnabled] = useState(false);
  const [autoMatcherInterval, setAutoMatcherInterval] = useState(60); // seconds
  const [lastMatcherRun, setLastMatcherRun] = useState(null);
  const [matcherRunning, setMatcherRunning] = useState(false);
  const [showMatcherFilterModal, setShowMatcherFilterModal] = useState(false);

  // Auto Email Sync state
  const [autoSyncEnabled, setAutoSyncEnabled] = useState(false);
  const [autoSyncInterval, setAutoSyncInterval] = useState(60); // seconds (default 1 minute)
  const [lastSyncRun, setLastSyncRun] = useState(null);
  const [syncRunning, setSyncRunning] = useState(false);
  const [syncStats, setSyncStats] = useState({ newTickets: 0, updatedTickets: 0 });

  // Server-side Background Sync state (24/7)
  const [serverSyncStatus, setServerSyncStatus] = useState(null);
  const [serverSyncLoading, setServerSyncLoading] = useState(false);

  // Filter values from backend (for complete dropdown lists)
  const [filterValues, setFilterValues] = useState(null);

  // Auto-refresh state - rafraîchit automatiquement quand de nouveaux tickets arrivent
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);
  const [lastTicketCount, setLastTicketCount] = useState(0);
  const autoRefreshIntervalRef = useRef(null);
  
  // Flag pour savoir si c'est un refresh silencieux (ne pas réinitialiser les filtres/page)
  const [isSilentRefresh, setIsSilentRefresh] = useState(false);

  // Charger les projets depuis le backend
  const fetchProjects = useCallback(async () => {
    try {
      setProjectsLoading(true);
      const response = await ticketService.getProjects();
      const projectNames = response.projects.map(p => p.name);
      setProjects(projectNames);
      
      // NE PAS changer automatiquement de projet !
      // On garde le projet actuel même s'il n'est pas dans la liste
      // (il sera créé automatiquement si nécessaire)
    } catch (error) {
      console.error('Error fetching projects:', error);
      // Fallback vers des projets par défaut
      setProjects(['WORLD CUP 2026', 'PSG', 'FFR', 'ROLAND GARROS']);
    } finally {
      setProjectsLoading(false);
    }
  }, []);

  // Ajouter un nouveau projet
  const handleAddProject = async () => {
    const name = window.prompt('Nom du nouveau projet :');
    if (name && name.trim()) {
      try {
        await ticketService.createProject(name.trim());
        toast.success(`Projet "${name.trim().toUpperCase()}" créé !`);
        await fetchProjects();
        // Demander confirmation avant de changer
        requestProjectChange(name.trim().toUpperCase());
        setShowProjectMenu(false);
      } catch (error) {
        console.error('Error creating project:', error);
        toast.error(error.response?.data?.detail || 'Erreur lors de la création du projet');
      }
    }
  };

  // Supprimer un projet avec DOUBLE VÉRIFICATION
  const handleDeleteProject = async (projectName) => {
    if (projectName === currentProject) {
      toast.error('Impossible de supprimer le projet actif. Changez de projet d\'abord.');
      return;
    }
    
    // Récupérer les stats du projet
    let ticketCount = 0;
    try {
      const stats = await ticketService.getProjectStats(projectName);
      ticketCount = stats.total_tickets || 0;
    } catch (e) {
      console.error('Error getting project stats:', e);
    }
    
    // ÉTAPE 1: Première confirmation
    const confirmMsg = `⚠️ ATTENTION ⚠️\n\nVoulez-vous vraiment supprimer le projet "${projectName}" ?\n\n📊 Ce projet contient ${ticketCount} ticket(s).\n\n❌ Cette action est IRRÉVERSIBLE !`;
    if (!window.confirm(confirmMsg)) return;
    
    // ÉTAPE 2: Double vérification - Taper le nom du projet
    const typedName = window.prompt(
      `🔐 DOUBLE VÉRIFICATION\n\nPour confirmer la suppression, tapez exactement le nom du projet :\n\n"${projectName}"`
    );
    
    if (!typedName || typedName.trim().toUpperCase() !== projectName.toUpperCase()) {
      toast.error('Le nom tapé ne correspond pas. Suppression annulée.');
      return;
    }
    
    try {
      const result = await ticketService.deleteProject(projectName, true);
      toast.success(`✅ Projet "${projectName}" supprimé définitivement (${result.deleted_tickets} tickets supprimés)`);
      await fetchProjects();
    } catch (error) {
      console.error('Error deleting project:', error);
      toast.error(error.response?.data?.detail || 'Erreur lors de la suppression');
    }
  };

  // Charger les projets au démarrage
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setLoadProgress(0);
    try {
      // Tous les endpoints lancés EN PARALLÈLE pour minimiser le temps d'attente.
      // On suit la progression au fur et à mesure qu'ils répondent.
      const TOTAL = 6;  // ⚠️ était 7 avant suppression de listPartialAttributions
      let done = 0;
      const bump = () => {
        done += 1;
        setLoadProgress(Math.round((done / TOTAL) * 100));
      };

      // 🚦 PAUSE le scanner AR pendant 45s pour libérer le serveur durant le chargement.
      // Le scanner se reprend tout seul après le timeout, OU on l'annule explicitement à la fin.
      // FLAG_REVERT: enlever ce bloc pour désactiver le pause.
      // ⚡ Fire-and-forget avec timeout court (3s) : si le serveur est bloqué par un scan IMAP,
      // on ne veut PAS attendre 60s ici (le user verrait "Chargement..." sans rien d'autre).
      // Le pause est best-effort — l'app continue immédiatement même si l'appel échoue.
      api.post('/action-requise/scanner/pause?seconds=45', null, { timeout: 3000 })
        .then(() => console.log('⏸️ Scanner AR mis en pause 45s pour libérer le serveur'))
        .catch(e => console.warn('Impossible de mettre le scanner en pause:', e?.message));

      // ❌ DÉSACTIVÉ — listPartialAttributions (34s sur PROD, n'était utile que pour Roland Garros)
      // Si besoin un jour : ticketService.listPartialAttributions(currentProject)

      const statsP = ticketService.getStats(currentProject).finally(bump);
      const deltaP = ticketService.getDelta(currentProject).finally(bump);
      const logsP = ticketService.getLogs(100).finally(bump);
      const filterValuesP = ticketService.getFilterValues(currentProject).finally(bump);

      // Affichage progressif : dès qu'un dataset arrive, on l'injecte dans le state.
      // Array.isArray : protège contre une réponse HTML/objet (backend indisponible → index.html 200)
      statsP.then(d => d && typeof d === 'object' && !Array.isArray(d) && setStats(d)).catch(() => {});
      deltaP.then(d => Array.isArray(d) && setDelta(d)).catch(() => {});
      logsP.then(d => Array.isArray(d) && setLogs(d)).catch(() => {});
      filterValuesP.then(d => d && typeof d === 'object' && setFilterValues(d)).catch(() => {});

      // 🚀 NEW: CHUNKED LOAD via /tickets/lite (3000 par chunk, ~50x plus léger gzippé)
      // FLAG_REVERT: passer USE_LITE_LOAD à false pour revenir à l'ancien comportement
      const USE_LITE_LOAD = false;  // ⚠️ Désactivé suite à bug "Aucun billet trouvé" sur PROD (10/06)
      const DEBUG_LITE = false;     // mettre true pour logger les détails de chaque chunk
      if (USE_LITE_LOAD) {
        const CHUNK = 3000;
        const t0 = performance.now();
        let allTickets = [];
        let skip = 0;
        let firstChunk = true;
        let chunkIdx = 0;
        while (true) {
          chunkIdx += 1;
          // eslint-disable-next-line no-await-in-loop
          const resp = await ticketService.getTicketsLite(currentProject, { limit: CHUNK, skip });
          const chunkTickets = resp?.tickets || [];
          allTickets = allTickets.concat(chunkTickets);
          // 🪵 LOGS DIAGNOSTIC
          console.log(`📦 Chunk #${chunkIdx} | reçu=${chunkTickets.length} | total cumul=${allTickets.length} / ${resp?.total} | has_more=${resp?.has_more} | t=${Math.round(performance.now() - t0)}ms`);
          if (DEBUG_LITE && chunkTickets[0]) {
            const t = chunkTickets[0];
            console.log(`  └─ sample ticket fields (${Object.keys(t).length}):`, Object.keys(t).sort());
            console.log(`  └─ sample type=${t.type} | attribue=${t.attribue} | statut=${t.statut} | ref_vente=${t.ref_vente?.slice(0,12)}`);
            const vc = allTickets.filter(x => x.type === 'VENTE').length;
            const ac = allTickets.filter(x => x.type === 'ACHAT').length;
            console.log(`  └─ après ce chunk : VENTES=${vc}, ACHATS=${ac}`);
          }
          if (firstChunk) {
            setTickets(allTickets);
            bump(); bump();
            setLoading(false);
            firstChunk = false;
          } else {
            setTickets(allTickets);
          }
          if (!resp?.has_more || chunkTickets.length === 0) break;
          skip += CHUNK;
        }
        const ventes = allTickets.filter(t => t.type === 'VENTE').length;
        const achats = allTickets.filter(t => t.type === 'ACHAT').length;
        console.log(`✅ LITE LOAD complet | total=${allTickets.length} (VENTES=${ventes} / ACHATS=${achats}) | ${Math.round(performance.now() - t0)}ms`);
      } else {
        const achatP = ticketService.getTickets(currentProject, { type: 'ACHAT', limit: 50000 }).finally(bump);
        const venteP = ticketService.getTickets(currentProject, { type: 'VENTE', limit: 50000 }).finally(bump);
        // 🛡️ allSettled au lieu de all : si une promise échoue (timeout, etc.),
        // on garde l'autre + on log au lieu de tout perdre.
        // Avant : Promise.all crashait TOUT le fetchData() à la moindre erreur réseau,
        // d'où "Erreur lors du chargement" + tableau vide alors que stats=10265.
        const [achatRes, venteRes] = await Promise.allSettled([achatP, venteP]);
        const achatData = achatRes.status === 'fulfilled' ? (achatRes.value || []) : [];
        const venteData = venteRes.status === 'fulfilled' ? (venteRes.value || []) : [];
        if (achatRes.status === 'rejected') {
          const det = achatRes.reason?.response?.data?.detail;
          console.error('❌ getTickets ACHAT failed:', achatRes.reason?.message || achatRes.reason);
          if (det) console.error('🔴 ACHAT BACKEND DETAIL:', det);
          toast.error('Erreur chargement ACHAT — réessaie (les VENTE sont chargées)');
        }
        if (venteRes.status === 'rejected') {
          const det = venteRes.reason?.response?.data?.detail;
          console.error('❌ getTickets VENTE failed:', venteRes.reason?.message || venteRes.reason);
          if (det) console.error('🔴 VENTE BACKEND DETAIL:', det);
          toast.error('Erreur chargement VENTE — réessaie (les ACHAT sont chargés)');
        }
        setTickets([...(Array.isArray(achatData) ? achatData : []), ...(Array.isArray(venteData) ? venteData : [])]);
      }

      // S'assurer que la barre arrive bien à 100%
      setLoadProgress(100);

      // ▶️ Reprend le scanner AR maintenant que l'app est chargée (au lieu d'attendre les 45s)
      // Fire-and-forget : pas besoin d'attendre la réponse, c'est juste un signal de reprise.
      api.post('/action-requise/scanner/resume', null, { timeout: 3000 })
        .then(() => console.log('▶️ Scanner AR repris'))
        .catch(() => { /* Pas grave : se reprend tout seul après la pause de 45s */ });
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Erreur lors du chargement des données');
    } finally {
      setLoading(false);
    }
  }, [currentProject]);

  // WebSocket presence + notifications ciblées
  const { connectedUsers, notifications, clearNotifications } = usePresence(authToken);

  // Refresh et clear notifications
  const handleRefreshFromNotification = useCallback(() => {
    fetchData();
    clearNotifications();
  }, [fetchData, clearNotifications]);

  // Load all tickets in background (utilisé par certains callbacks onComplete pour recharger).
  // 🛠️ FIX FEV 2026 : sans `limit`, le backend appliquait son default=1000 → OVERWRITE
  // de l'état tickets (10624) avec seulement 1000 → onglet VENTE affichait "5 lignes / 2898".
  const loadAllTickets = useCallback(async () => {
    try {
      const allTickets = await ticketService.getTickets(currentProject, { limit: 50000 });
      if (Array.isArray(allTickets)) setTickets(allTickets);
    } catch (error) {
      // Don't show error toast for aborted requests (happens during navigation)
      if (error?.name !== 'AbortError' && error?.code !== 'ERR_CANCELED') {
        console.error('Error loading all tickets:', error);
        // Silent fail - initial data is already loaded
      }
    }
  }, [currentProject]);

  // État pour le changement de projet (pour forcer un rechargement propre)
  const [projectSwitching, setProjectSwitching] = useState(false);
  const previousProjectRef = useRef(currentProject);

  // Effet pour nettoyer les données quand on change de projet
  useEffect(() => {
    if (previousProjectRef.current !== currentProject) {
      console.log(`🔄 Changement de projet: ${previousProjectRef.current} → ${currentProject}`);
      
      // Marquer qu'on est en train de changer de projet
      setProjectSwitching(true);
      
      // EFFACER TOUTES LES DONNÉES IMMÉDIATEMENT
      setTickets([]);
      setStats(null);
      setDelta([]);
      setLogs([]);
      setFilterValues(null);
      setTableFilteredTickets([]);
      setLastTicketCount(0);
      
      // Mettre à jour la référence
      previousProjectRef.current = currentProject;
      
      // Petit délai pour s'assurer que l'UI est nettoyée avant de recharger
      setTimeout(() => {
        setProjectSwitching(false);
      }, 100);
    }
  }, [currentProject]);

  // Load source phones for current project
  const loadSourcePhones = useCallback(async () => {
    if (!currentProject) return;
    try {
      const res = await api.get('/source-phones', { params: { project: currentProject } });
      const map = {};
      (res.data.phones || []).forEach(p => { map[p.source] = { phone: p.phone || '', email: p.email || '', sheet_url: p.sheet_url || '' }; });
      setSourcePhones(map);
    } catch (e) { console.error('Source phones load error:', e); }
  }, [currentProject]);

  useEffect(() => {
    fetchData();
    loadSourcePhones();
    // Load custom stadium plans
    api.get('/stadiums/custom-plans').then(res => {
      if (res.data) applyCustomPlans(res.data);
    }).catch(() => {});
  }, [fetchData, loadSourcePhones]);

  // 🏆 WC2026 — charge le mapping résolu (1A=Mexique, etc.) + le match-lookup api-football au mount + refresh toutes les 5 min
  // Politique : seuls 1X/2X (sûrs) sont résolus, les 3X/Y/Z (best-thirds incertains) restent en placeholder.
  // Le match-lookup permet de croiser date_evenement → vraies équipes api-football quand FIFA a déterminé le bracket.
  useEffect(() => {
    const loadResolved = async () => {
      try {
        const [resolvedData, lookupData] = await Promise.all([
          wc26Service.getResolvedTeams(),
          wc26Service.getMatchLookup(),
        ]);
        setResolvedTeams(resolvedData?.resolved || {});
        setMatchLookup(lookupData?.by_date || {});
      } catch { /* silent */ }
    };
    loadResolved();
    const interval = setInterval(loadResolved, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // 🛠️ FIX FEV 2026 : SUPPRESSION de l'useEffect "loadAllTickets après 2s".
  // C'était un appel redondant qui rechargeait tous les tickets 2s après le `fetchData` initial
  // (qui charge déjà ACHAT+VENTE avec limit=50000 = TOUT). Le double appel sans limite causait
  // l'overwrite de l'état avec seulement 1000 tickets (default backend) → "5 lignes / 2898 total".
  // loadAllTickets reste disponible pour les callbacks onComplete (réattribuer une vente, etc.).

  // ==================== AUTO-REFRESH ====================
  // Vérifie toutes les 30 secondes si :
  //  - le nombre TOTAL de tickets a changé
  //  - OU le compteur ACTION REQUISE / LITIGE a changé (auto-flag par scanner email)
  // → rafraîchit automatiquement l'interface SANS réinitialiser les filtres/page
  const lastFlagsCount = useRef({ ar: 0, litige: 0 });

  useEffect(() => {
    if (!isAuthenticated || !autoRefreshEnabled) return;

    const checkForNewTickets = async () => {
      try {
        // Récupérer juste les stats (rapide) pour vérifier le nombre de tickets
        const newStats = await ticketService.getStats(currentProject);
        const newTotal = (newStats?.achats?.total || 0) + (newStats?.ventes?.total || 0);
        const newAR = newStats?.action_requise_count || 0;
        const newLitige = newStats?.litige_count || 0;

        // Détection des changements
        const totalChanged = lastTicketCount > 0 && newTotal !== lastTicketCount;
        const arChanged = newAR !== lastFlagsCount.current.ar;
        const litigeChanged = newLitige !== lastFlagsCount.current.litige;

        if (totalChanged || arChanged || litigeChanged) {
          const reason = totalChanged
            ? `tickets ${lastTicketCount} → ${newTotal}`
            : (arChanged ? `ACTION REQUISE ${lastFlagsCount.current.ar} → ${newAR}` : `LITIGE ${lastFlagsCount.current.litige} → ${newLitige}`);
          console.log(`🔄 Auto-refresh: ${reason}`);
          
          // Marquer comme refresh silencieux
          setIsSilentRefresh(true);
          
          // Mise à jour silencieuse des stats, delta, logs
          const [statsData, deltaData, logsData] = await Promise.all([
            ticketService.getStats(currentProject),
            ticketService.getDelta(currentProject),
            ticketService.getLogs(100),
          ]);
          if (statsData && typeof statsData === 'object' && !Array.isArray(statsData)) setStats(statsData);
          if (Array.isArray(deltaData)) setDelta(deltaData);
          if (Array.isArray(logsData)) setLogs(logsData);
          
          // Charger les nouveaux tickets
          const [achatData, venteData] = await Promise.all([
            ticketService.getTickets(currentProject, { type: 'ACHAT', limit: 50000 }),
            ticketService.getTickets(currentProject, { type: 'VENTE', limit: 50000 }),
          ]);
          
          // Mise à jour intelligente: garder les IDs existants à leur place, ajouter les nouveaux
          const newTickets = [...achatData, ...venteData];
          setTickets(prevTickets => {
            // Créer un map des nouveaux tickets par ID
            const newTicketsMap = new Map(newTickets.map(t => [t.id, t]));
            
            // Mettre à jour les tickets existants et ajouter les nouveaux
            const existingIds = new Set(prevTickets.map(t => t.id));
            
            // Mettre à jour les tickets existants avec les nouvelles données
            const updatedExisting = prevTickets.map(t => newTicketsMap.get(t.id) || t);
            
            // Trouver les nouveaux tickets (pas dans existingIds)
            const brandNewTickets = newTickets.filter(t => !existingIds.has(t.id));
            
            // Retourner les existants mis à jour + les nouveaux à la fin
            return [...updatedExisting, ...brandNewTickets];
          });
          
          // Notification discrète (uniquement si total a changé)
          const diff = newTotal - lastTicketCount;
          if (totalChanged) {
            if (diff > 0) {
              toast.success(`${diff} nouveau(x) ticket(s) ajouté(s)`, { duration: 3000 });
            } else if (diff < 0) {
              toast.info(`${Math.abs(diff)} ticket(s) supprimé(s)`, { duration: 3000 });
            }
          } else if (arChanged) {
            const arDiff = newAR - lastFlagsCount.current.ar;
            if (arDiff > 0) toast.info(`🟡 ${arDiff} nouveau(x) ACTION REQUISE détecté(s)`, { duration: 3000 });
          }

          // Mise à jour des compteurs locaux
          lastFlagsCount.current = { ar: newAR, litige: newLitige };

          // Fin du refresh silencieux
          setTimeout(() => setIsSilentRefresh(false), 100);
        }
        
        setLastTicketCount(newTotal);
      } catch (error) {
        console.error('Auto-refresh error:', error);
        setIsSilentRefresh(false);
      }
    };

    // Vérifier toutes les 30 secondes
    autoRefreshIntervalRef.current = setInterval(checkForNewTickets, 30000);
    
    return () => {
      if (autoRefreshIntervalRef.current) {
        clearInterval(autoRefreshIntervalRef.current);
      }
    };
  }, [isAuthenticated, autoRefreshEnabled, currentProject, lastTicketCount]);

  // Mettre à jour lastTicketCount + lastFlagsCount quand les données sont chargées initialement
  useEffect(() => {
    if (stats) {
      const total = (stats?.achats?.total || 0) + (stats?.ventes?.total || 0);
      setLastTicketCount(total);
      lastFlagsCount.current = {
        ar: stats?.action_requise_count || 0,
        litige: stats?.litige_count || 0,
      };
    }
  }, [stats]);

  const handleImport = async (content, subject, fromEmail) => {
    const result = await ticketService.parseEmail(content, subject, fromEmail);
    toast.success(`${result.tickets_created} billet(s) importé(s)`);
    fetchData();
    return result;
  };

  // State for duplicate warning
  const [duplicateData, setDuplicateData] = useState(null);
  const [pendingImportTickets, setPendingImportTickets] = useState(null);

  const handleBulkImport = async (tickets) => {
    // Check for duplicates first
    try {
      const dupResult = await ticketService.checkDuplicates(tickets, currentProject);
      if (dupResult.has_duplicates) {
        // Store pending tickets and show duplicate warning
        setPendingImportTickets(tickets);
        setDuplicateData(dupResult);
        return { paused: true, duplicates: dupResult.duplicate_count };
      }
    } catch (e) {
      console.warn('Duplicate check failed, proceeding with import:', e);
    }
    
    // No duplicates — proceed
    return await executeImport(tickets);
  };

  const executeImport = async (tickets) => {
    const result = await ticketService.bulkImport(tickets, currentProject);
    const messages = [];
    if (result.created > 0) messages.push(`${result.created} créé(s)`);
    if (result.updated > 0) messages.push(`${result.updated} mis à jour`);
    if (result.skipped > 0) messages.push(`${result.skipped} ignoré(s)`);
    const message = messages.length > 0 ? messages.join(', ') : 'Aucun changement';
    toast.success(`Import terminé: ${message}`);
    fetchData();
    return result;
  };

  const handleForceImport = async () => {
    if (pendingImportTickets) {
      await executeImport(pendingImportTickets);
      setPendingImportTickets(null);
      setDuplicateData(null);
    }
  };

  const handleImportWithoutDuplicates = async () => {
    if (pendingImportTickets && duplicateData) {
      const dupIndexes = new Set(duplicateData.duplicates.map(d => d.index));
      const cleanTickets = pendingImportTickets.filter((_, i) => !dupIndexes.has(i));
      if (cleanTickets.length > 0) {
        await executeImport(cleanTickets);
      } else {
        toast.info('Tous les billets sont des doublons, rien à importer');
      }
      setPendingImportTickets(null);
      setDuplicateData(null);
    }
  };

  const handleCancelDuplicateImport = () => {
    setPendingImportTickets(null);
    setDuplicateData(null);
  };

  const handleInboxProcess = async (emailContent) => {
    // Process email content and create tickets
    const result = await ticketService.parseEmail(emailContent, '', '', currentProject);
    fetchData();
    return result;
  };

  const handleSaveTicket = async (data, ticketId) => {
    try {
      if (ticketId) {
        await ticketService.updateTicket(ticketId, data);
        toast.success('Billet mis à jour');
      } else {
        await ticketService.createTicket({ ...data, project: currentProject });
      }
      await fetchData();
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde');
      throw error;
    }
  };

  const handleUnmatch = async (ticketId) => {
    try {
      await ticketService.unmatchTicket(ticketId);
      toast.success('Ticket déassocié');
      await fetchData();  // ✅ Attendre le rechargement
    } catch (error) {
      console.error('Unmatch error:', error);
      toast.error(`Erreur: ${error.response?.data?.detail || error.message || 'Erreur inconnue'}`);
    }
  };

  const handleDelete = async (ticketId) => {
    if (!window.confirm('Supprimer ce billet ?')) return;
    try {
      await ticketService.deleteTicket(ticketId);
      toast.success('Billet supprimé');
      await fetchData();  // ✅ Attendre le rechargement
    } catch (error) {
      // Extract error message from API response
      const errorMessage = error.response?.data?.detail || 'Erreur lors de la suppression';
      toast.error(errorMessage);
    }
  };

  const handleBulkDelete = async (ticketIds, forceDelete = false) => {
    try {
      const result = await ticketService.bulkDeleteTickets(ticketIds, false, null, currentProject, forceDelete);
      
      // Si des tickets attribués ont été détectés et qu'on n'a pas forcé la suppression
      if (result.needs_confirmation) {
        // Demander confirmation à l'utilisateur
        const confirmDelete = window.confirm(
          `⚠️ ATTENTION ⚠️\n\n${result.message}\n\nCliquez OK pour supprimer quand même, ou Annuler pour garder les tickets.`
        );
        
        if (confirmDelete) {
          // Relancer avec force_delete = true
          const forceResult = await ticketService.bulkDeleteTickets(ticketIds, false, null, currentProject, true);
          toast.success(`${forceResult.deleted} billet(s) supprimé(s) (suppression forcée)`);
          await fetchData();
        } else {
          toast.info('Suppression annulée');
        }
        return;
      }
      
      toast.success(`${result.deleted} billet(s) supprimé(s)`);
      await fetchData();  // ✅ Attendre le rechargement
    } catch (error) {
      // Extract error message from API response
      const errorMessage = error.response?.data?.detail || 'Erreur lors de la suppression';
      toast.error(errorMessage);
    }
  };

  const handleUpdateStatus = async (ticketId, status) => {
    try {
      await ticketService.updateTicket(ticketId, { statut: status });
      toast.success('Statut mis à jour');
      await fetchData();  // ✅ Attendre le rechargement des données
    } catch (error) {
      toast.error('Erreur lors de la mise à jour');
    }
  };

  const handleEdit = (ticket) => {
    setEditingTicket(ticket);
    setShowFormModal(true);
  };

  // Handler for manual attribution from VENTE view
  const handleAttribuerVente = (venteTicket) => {
    setSelectedVenteForAttribution(venteTicket);
    setShowAttribuerVenteModal(true);
  };

  // Handler called after bulk-edit succeeded — mise à jour locale (préserve filtres & sélection)
  const handleBulkUpdated = ({ ids, field, value }) => {
    if (!ids || ids.length === 0 || !field) return;
    const idSet = new Set(ids);
    setTickets(prev => prev.map(t => idSet.has(t.id) ? { ...t, [field]: value } : t));
  };

  // Handler to update clients array on a VENTE ticket (inline edit)
  const handleUpdateClients = async (ticketId, clientsData) => {
    try {
      // Filter out completely empty clients — if all fields blank, remove
      const cleaned = clientsData.filter(c => 
        (c.nom && c.nom.trim()) || (c.dob && c.dob.trim()) || (c.email && c.email.trim())
      );
      await ticketService.updateTicket(ticketId, { clients: cleaned });
      // Update locally
      setTickets(prev => prev.map(t => 
        t.id === ticketId ? { ...t, clients: cleaned } : t
      ));
      toast.success(cleaned.length > 0 ? 'Clients mis à jour' : 'Clients réinitialisés');
    } catch (error) {
      console.error('Error updating clients:', error);
      toast.error('Erreur lors de la mise à jour des clients');
    }
  };

  // Handler for special attribution (different category)
  const handleSpecialAttribution = (venteTicket) => {
    setSelectedVenteForAttribution(venteTicket);
    setShowSpecialAttributionModal(true);
  };

  const handleMarkAttribue = async (ticketId, attribue) => {
    try {
      // Get the ticket BEFORE the API call to get its ref_vente
      const targetTicket = tickets.find(t => t.id === ticketId);
      const targetRefVente = targetTicket?.ref_vente || '';
      
      const result = await ticketService.markAttribue(ticketId, attribue);
      
      if (!attribue) {
        // Désattribution - update locally based on ref_vente
        // Use either the result ref_vente or the ticket's own ref_vente
        const refVente = result.ref_vente || targetRefVente;
        toast.success(result.message || 'Désattribué');
        
        // Update tickets locally - for ACHAT clear data, for VENTE only clear attribue/statut
        setTickets(prev => prev.map(t => {
          // Check if this ticket is affected:
          // 1. Same id as clicked ticket
          // 2. Has same ref_vente as the target (for cascade)
          const isClickedTicket = t.id === ticketId;
          const hasSameRefVente = refVente && refVente.trim() !== '' && t.ref_vente === refVente;
          const isAffected = isClickedTicket || hasSameRefVente;
          
          if (isAffected) {
            if (t.type === 'ACHAT') {
              // ACHAT: clear TOUTES les données d'attribution (PAS ref_achat = donnée originale)
              return { 
                ...t, 
                attribue: false, 
                ref_vente: '', 
                ref_vente_attribuer: '',
                nom_client: '', 
                mail_client: '',
                dob_client: '',
                clients: [],
                source_vente: '',
                mail_du_compte_vente: '',
                statut: '',
                linked_preuve_url: ''
              };
            } else {
              // VENTE: clear liens attribution + champs linked computed
              // PAS ref_vente/nom_client/mail_client/dob_client = données de base
              return { 
                ...t, 
                attribue: false, 
                statut: '',
                ref_achat: '',
                achat_ids: [],
                linked_mail_du_compte: '',
                linked_pw_du_compte: '',
                linked_source_achat: ''
              };
            }
          }
          return t;
        }));
        
        // Rafraîchir les stats et delta
        const [newStats, newDelta] = await Promise.all([
          ticketService.getStats(currentProject),
          ticketService.getDelta(currentProject)
        ]);
        if (newStats && typeof newStats === 'object' && !Array.isArray(newStats)) setStats(newStats);
        if (Array.isArray(newDelta)) setDelta(newDelta);
      } else {
        // Attribuer - update locally
        setTickets(prev => prev.map(t => {
          if (t.id === ticketId) {
            return { ...t, attribue: true };
          }
          return t;
        }));
        toast.success('Attribué');
        
        // Rafraîchir les stats et delta
        const [newStats, newDelta] = await Promise.all([
          ticketService.getStats(currentProject),
          ticketService.getDelta(currentProject)
        ]);
        setStats(newStats);
        setDelta(newDelta);
      }
    } catch (error) {
      console.error('Mark attribue error:', error);
      toast.error(`Erreur: ${error.response?.data?.detail || error.message || 'Erreur de connexion'}`);
    }
  };

  // Handler to validate a ticket (mark as VALIDE - green, locked)
  const handleValidateTicket = async (ticketId) => {
    try {
      const result = await ticketService.validateTicket(ticketId);
      const refVente = result.ref_vente;
      
      toast.success(result.message);
      
      setTickets(prev => prev.map(t => {
        const isAffected = t.id === ticketId || (refVente && t.ref_vente === refVente);
        if (isAffected) {
          return { ...t, statut: 'VALIDE', attribue: true };
        }
        return t;
      }));
      
      const [newStats, newDelta] = await Promise.all([
        ticketService.getStats(currentProject),
        ticketService.getDelta(currentProject)
      ]);
      setStats(newStats);
      setDelta(newDelta);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || 'Erreur lors de la validation');
    }
  };

  // Toggle LITIGE (manual dispute flag) — propagates to linked ACHATs when set on a VENTE
  const handleToggleLitige = async (ticket, nextValue) => {
    try {
      const targetValue = nextValue ?? !ticket.litige;
      const result = await ticketService.toggleLitige(ticket.id, targetValue);
      toast.success(result.message);

      const refVente = (ticket.ref_vente || '').trim();
      const isVenteWithRef = ticket.type === 'VENTE' && refVente;
      setTickets(prev => prev.map(t => {
        const affected = t.id === ticket.id
          || (isVenteWithRef && (t.ref_vente === refVente || t.ref_vente_attribuer === ticket.id));
        if (affected) {
          return {
            ...t,
            litige: targetValue,
            litige_date: targetValue ? new Date().toISOString() : null,
          };
        }
        return t;
      }));
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || 'Erreur lors de la mise en litige');
    }
  };

  // Toggle ACTION REQUISE (manual yellow flag) — same propagation as LITIGE
  const handleToggleActionRequise = async (ticket, nextValue) => {
    try {
      const targetValue = nextValue ?? !ticket.action_requise;
      const result = await ticketService.toggleActionRequise(ticket.id, targetValue);
      toast.success(result.message);

      const refVente = (ticket.ref_vente || '').trim();
      const isVenteWithRef = ticket.type === 'VENTE' && refVente;
      setTickets(prev => prev.map(t => {
        const affected = t.id === ticket.id
          || (isVenteWithRef && (t.ref_vente === refVente || t.ref_vente_attribuer === ticket.id));
        if (affected) {
          return {
            ...t,
            action_requise: targetValue,
            action_requise_date: targetValue ? new Date().toISOString() : null,
          };
        }
        return t;
      }));
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || 'Erreur lors de la mise à jour');
    }
  };



  // Handler to revert a delivered (LIVRE/VALIDE) ticket back to ATTRIBUE (statut vide)
  // Garde la liaison vente/client intacte
  const handleUnvalidate = async (ticketId) => {
    try {
      const ticket = tickets.find(t => t.id === ticketId);
      const refVente = ticket?.ref_vente;
      // statut vide + on garde attribue=true
      await ticketService.updateTicket(ticketId, { statut: '' });
      toast.success('Ticket repassé en ATTRIBUÉ');
      
      // Mise à jour locale : ce ticket + ACHATs liés
      setTickets(prev => prev.map(t => {
        const isThis = t.id === ticketId;
        const isLinkedAchat = t.type === 'ACHAT' && (t.ref_vente === ticketId || (refVente && t.ref_vente === refVente));
        if (isThis || isLinkedAchat) return { ...t, statut: '', attribue: true };
        return t;
      }));
      
      const [newStats, newDelta] = await Promise.all([
        ticketService.getStats(currentProject),
        ticketService.getDelta(currentProject)
      ]);
      setStats(newStats);
      setDelta(newDelta);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || 'Erreur lors du retour à attribué');
    }
  };

  // Handler to mark a ticket as LIVRE (delivered - red, final)
  const handleMarkLivre = async (ticketId) => {
    try {
      const ticket = tickets.find(t => t.id === ticketId);
      await ticketService.updateTicket(ticketId, { statut: 'LIVRE' });
      toast.success('Ticket marqué comme livré');
      
      // Update local state: mark this ticket + linked ACHATs as LIVRE
      // ACHATs may reference the VENTE by ref_vente = vente.id OR ref_vente = vente.ref_vente
      const refVente = ticket?.ref_vente;
      setTickets(prev => prev.map(t => {
        if (t.id === ticketId) return { ...t, statut: 'LIVRE' };
        if (t.type === 'ACHAT' && (t.ref_vente === ticketId || (refVente && t.ref_vente === refVente))) return { ...t, statut: 'LIVRE' };
        return t;
      }));
      
      const [newStats, newDelta] = await Promise.all([
        ticketService.getStats(currentProject),
        ticketService.getDelta(currentProject)
      ]);
      setStats(newStats);
      setDelta(newDelta);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || 'Erreur lors du marquage livré');
    }
  };

  const handleRunMatching = async (silent = false) => {
    if (matcherRunning) return;
    setMatcherRunning(true);
    try {
      if (!silent) toast.info('Attribution automatique en cours...');
      const result = await ticketService.autoMatch(currentProject);
      setLastMatcherRun(new Date());
      if (!silent || result.matched_ventes > 0) {
        toast.success(result.message || `${result.matched_ventes} match(s) trouvé(s)`);
      }
      fetchData();
    } catch (error) {
      console.error('Matching error:', error);
      if (!silent) {
        let errorMsg = 'Erreur inconnue';
        const detail = error.response?.data?.detail;
        
        if (detail) {
          errorMsg = detail;
        } else if (error.message?.includes('timeout') || error.code === 'ECONNABORTED') {
          errorMsg = 'Le matching prend trop de temps. Avec beaucoup de tickets, cela peut durer plusieurs minutes. Réessayez ou attendez.';
        } else if (error.message?.includes('Network') || error.code === 'ERR_NETWORK') {
          errorMsg = 'Erreur de connexion au serveur. Vérifiez votre connexion internet.';
        } else if (error.response?.status === 500) {
          errorMsg = 'Erreur serveur lors du matching. Contactez le support si le problème persiste.';
        } else {
          errorMsg = error.message || 'Erreur inconnue';
        }
        
        toast.error(`Erreur matching: ${errorMsg}`);
      }
    } finally {
      setMatcherRunning(false);
    }
  };

  // Ouvrir la modal de sélection des sources à ignorer
  const handleOpenMatcherFilterModal = () => {
    setShowMatcherFilterModal(true);
  };

  // Matching filtré avec les sources sélectionnées
  const handleRunMatchingFiltered = async (excludedSources) => {
    if (matcherRunning) return;
    setMatcherRunning(true);
    setShowMatcherFilterModal(false);
    
    try {
      const excludedStr = excludedSources.length > 0 
        ? `sans ${excludedSources.join(', ')}` 
        : 'toutes sources';
      toast.info(`Attribution en cours (${excludedStr})...`);
      
      const result = await ticketService.autoMatchFiltered(currentProject, excludedSources);
      setLastMatcherRun(new Date());
      
      const matchedCount = result.matched_ventes || 0;
      if (matchedCount > 0) {
        toast.success(`${matchedCount} match(s) trouvé(s) !`);
      } else {
        toast.info('Aucun nouveau match trouvé.');
      }
      
      fetchData();
    } catch (error) {
      console.error('Matching filtered error:', error);
      let errorMsg = 'Erreur inconnue';
      const detail = error.response?.data?.detail;
      
      if (detail) {
        errorMsg = detail;
      } else if (error.message?.includes('timeout') || error.code === 'ECONNABORTED') {
        errorMsg = 'Le matching prend trop de temps. Réessayez.';
      } else if (error.response?.status === 500) {
        errorMsg = 'Erreur serveur lors du matching.';
      } else {
        errorMsg = error.message || 'Erreur inconnue';
      }
      
      toast.error(`Erreur matching: ${errorMsg}`);
    } finally {
      setMatcherRunning(false);
    }
  };

  // Auto Matcher Timer
  const autoMatcherRef = useRef(null);
  
  useEffect(() => {
    if (autoMatcherEnabled && isAuthenticated) {
      // Clear any existing interval
      if (autoMatcherRef.current) {
        clearInterval(autoMatcherRef.current);
      }
      
      // Run immediately on enable
      handleRunMatching(true);
      
      // Set up interval
      autoMatcherRef.current = setInterval(() => {
        handleRunMatching(true);
      }, autoMatcherInterval * 1000);
      
      toast.success(`Auto-Matcher activé (${autoMatcherInterval}s)`);
    } else {
      if (autoMatcherRef.current) {
        clearInterval(autoMatcherRef.current);
        autoMatcherRef.current = null;
      }
    }
    
    return () => {
      if (autoMatcherRef.current) {
        clearInterval(autoMatcherRef.current);
      }
    };
  }, [autoMatcherEnabled, autoMatcherInterval, isAuthenticated, currentProject]);

  const toggleAutoMatcher = () => {
    setAutoMatcherEnabled(prev => !prev);
  };

  // Auto Email Sync - handler function
  const handleAutoSync = async (silent = false) => {
    if (syncRunning) return;
    setSyncRunning(true);
    try {
      const result = await ticketService.autoSyncEmails(currentProject);
      setLastSyncRun(new Date());
      
      const hasNewData = result.new_tickets > 0 || result.updated_tickets > 0;
      
      if (hasNewData) {
        setSyncStats({
          newTickets: syncStats.newTickets + result.new_tickets,
          updatedTickets: syncStats.updatedTickets + result.updated_tickets
        });
        
        // Refresh data when new tickets found
        fetchData();
        
        if (!silent) {
          toast.success(`📧 ${result.new_tickets} nouveau(x), ${result.updated_tickets} mis à jour`);
        } else {
          // Show subtle notification even in silent mode when new data
          toast.info(`📧 Sync: ${result.message}`, { duration: 3000 });
        }
      }
    } catch (error) {
      if (!silent) {
        let errorMsg = 'Erreur sync email';
        const detail = error.response?.data?.detail;
        
        if (detail) {
          errorMsg = detail;
        } else if (error.message?.includes('timeout')) {
          errorMsg = 'La synchronisation email a pris trop de temps. Réessayez.';
        } else if (error.response?.status === 401) {
          errorMsg = 'Identifiants email incorrects. Vérifiez la configuration.';
        } else if (error.response?.status === 500) {
          errorMsg = 'Erreur serveur lors de la synchronisation. Le serveur IMAP est peut-être inaccessible.';
        }
        
        toast.error(errorMsg);
      }
      console.error('Auto-sync error:', error);
    } finally {
      setSyncRunning(false);
    }
  };

  // 🔄 RE-SCAN COMPLET - Vérifie tous les emails même ceux déjà traités
  const [forceRescanRunning, setForceRescanRunning] = useState(false);
  
  const handleForceRescan = async () => {
    if (forceRescanRunning) return;
    
    setForceRescanRunning(true);
    toast.info('🔄 Re-scan complet en cours... Cela peut prendre plusieurs minutes.');
    
    try {
      const result = await ticketService.forceRescanEmails(currentProject);
      
      if (result.new_tickets > 0 || result.updated_tickets > 0) {
        fetchData();
        toast.success(`✅ Re-scan terminé: ${result.new_tickets} nouveau(x), ${result.updated_tickets} mis à jour`);
      } else {
        toast.success('✅ Re-scan terminé: Tous les tickets étaient déjà importés');
      }
    } catch (error) {
      toast.error('❌ Erreur lors du re-scan complet');
      console.error('Force rescan error:', error);
    } finally {
      setForceRescanRunning(false);
    }
  };

  // Auto Email Sync Timer
  const autoSyncRef = useRef(null);
  
  useEffect(() => {
    if (autoSyncEnabled && isAuthenticated) {
      // Clear any existing interval
      if (autoSyncRef.current) {
        clearInterval(autoSyncRef.current);
      }
      
      // Run immediately on enable
      handleAutoSync(true);
      
      // Set up interval
      autoSyncRef.current = setInterval(() => {
        handleAutoSync(true);
      }, autoSyncInterval * 1000);
      
      toast.success(`📧 Sync auto activée (${autoSyncInterval}s)`);
    } else {
      if (autoSyncRef.current) {
        clearInterval(autoSyncRef.current);
        autoSyncRef.current = null;
      }
    }
    
    return () => {
      if (autoSyncRef.current) {
        clearInterval(autoSyncRef.current);
      }
    };
  }, [autoSyncEnabled, autoSyncInterval, isAuthenticated, currentProject]);

  const toggleAutoSync = () => {
    setAutoSyncEnabled(prev => !prev);
  };

  // ==================== SERVER-SIDE BACKGROUND SYNC (24/7) ====================
  
  // Fetch server sync status on mount and periodically
  const fetchServerSyncStatus = useCallback(async () => {
    try {
      const status = await ticketService.getBackgroundSyncStatus();
      setServerSyncStatus(status);
    } catch (error) {
      console.error('Error fetching server sync status:', error);
    }
  }, []);

  // Check server sync status on mount and every 30 seconds
  useEffect(() => {
    if (isAuthenticated) {
      fetchServerSyncStatus();
      const interval = setInterval(fetchServerSyncStatus, 30000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, fetchServerSyncStatus]);

  // Start server-side background sync
  const handleStartServerSync = async (intervalMinutes = 5) => {
    setServerSyncLoading(true);
    try {
      const result = await ticketService.startBackgroundSync(intervalMinutes, currentProject);
      setServerSyncStatus(result.status);
      toast.success(result.message);
    } catch (error) {
      toast.error('Erreur lors du démarrage du sync serveur');
    } finally {
      setServerSyncLoading(false);
    }
  };

  // Stop server-side background sync
  const handleStopServerSync = async () => {
    setServerSyncLoading(true);
    try {
      const result = await ticketService.stopBackgroundSync();
      setServerSyncStatus(result.status);
      toast.success(result.message);
    } catch (error) {
      toast.error('Erreur lors de l\'arrêt du sync serveur');
    } finally {
      setServerSyncLoading(false);
    }
  };

  // State for confirmation dialog
  const [showDesattribuerConfirm, setShowDesattribuerConfirm] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showSystemHealth, setShowSystemHealth] = useState(false);
  const [snapshots, setSnapshots] = useState([]);
  const [loadingSnapshots, setLoadingSnapshots] = useState(false);

  const handleDesattribuerAll = async () => {
    // Show custom confirmation instead of window.confirm
    setShowDesattribuerConfirm(true);
  };

  const confirmDesattribuerAll = async () => {
    setShowDesattribuerConfirm(false);
    try {
      const result = await ticketService.desattribuerAllWithBackup(currentProject, userName || 'SYSTÈME');
      toast.success(result.message || 'Tout désattribué avec succès');
      
      // Update ALL tickets locally instead of refetching (prevents flickering)
      setTickets(prev => prev.map(t => {
        // PROTÉGER les VALIDÉ — pas touché par "Tout désattribuer"
        const statut = (t.statut || '').toUpperCase();
        if (statut === 'VALIDE' || statut === 'VALIDÉ' || statut === 'ANNULEE' || statut === 'ANNULÉ') {
          return t;
        }
        
        if (t.type === 'ACHAT') {
          // ACHAT: clear toutes les données d'attribution (PAS ref_achat = donnée originale)
          return {
            ...t,
            attribue: false,
            ref_vente: '',
            ref_vente_attribuer: '',
            nom_client: '',
            mail_client: '',
            dob_client: '',
            clients: [],
            source_vente: '',
            mail_du_compte_vente: '',
            statut: '',
            linked_preuve_url: ''
          };
        } else {
          // VENTE: clear liens attribution + champs linked computed
          // PAS ref_vente/nom_client/mail_client/dob_client = données de base
          return {
            ...t,
            attribue: false,
            statut: '',
            ref_achat: '',
            achat_ids: [],
            linked_mail_du_compte: '',
            linked_pw_du_compte: '',
            linked_source_achat: ''
          };
        }
      }));
      
      // Refresh stats only (lightweight)
      const newStats = await ticketService.getStats(currentProject);
      setStats(newStats);
    } catch (error) {
      console.error('Erreur désattribution:', error);
      const errorMsg = error?.response?.data?.detail || error?.message || 'Erreur inconnue';
      toast.error(`Erreur: ${errorMsg}`);
    }
  };

  const loadSnapshots = async () => {
    setLoadingSnapshots(true);
    try {
      const data = await ticketService.getSnapshots(currentProject);
      setSnapshots(data || []);
    } catch (e) {
      console.error(e);
    }
    setLoadingSnapshots(false);
  };

  const handleRestoreSnapshot = async (snapshotId) => {
    if (!window.confirm('Restaurer cette version ? Toutes les données actuelles seront remplacées.')) return;
    try {
      const result = await ticketService.restoreSnapshot(snapshotId, currentProject);
      if (result.success) {
        toast.success(`Version restaurée (${result.restored_count} tickets)`);
        setShowHistoryModal(false);
        await fetchData();  // ✅ Attendre le rechargement
      } else {
        toast.error(result.error || 'Erreur');
      }
    } catch (e) {
      toast.error('Erreur lors de la restauration');
    }
  };

  const handleClearLogs = async () => {
    try {
      await ticketService.clearLogs();
      toast.success('Logs effacés');
      setLogs([]);
    } catch (error) {
      toast.error('Erreur lors de l\'effacement');
    }
  };

  // Mark rocketposter tickets
  const handleMarkRocketposter = async () => {
    try {
      const response = await fetch(`/api/tickets/mark-rocketposter?project=${encodeURIComponent(currentProject)}`, {
        method: 'POST',
      });
      
      if (!response.ok) {
        throw new Error('Erreur serveur');
      }
      
      const result = await response.json();
      
      if (result.updated > 0) {
        toast.success(`✅ ${result.updated} tickets marqués "rocketposter"`, {
          description: `${result.already_marked} déjà marqués`
        });
        // Refresh data to see the changes
        await fetchData();
      } else if (result.already_marked > 0) {
        toast.info(`Tous les ${result.already_marked} tickets rocketposter sont déjà marqués`);
      } else {
        toast.info('Aucun ticket avec 0@rocketposter.com trouvé');
      }
    } catch (error) {
      console.error('Error marking rocketposter:', error);
      toast.error('Erreur lors du marquage rocketposter');
    }
  };

  // ============ ROLAND GARROS EXPORT HELPERS ============
  const extractRGRound = (evenement) => {
    if (!evenement) return '';
    // Format: "M15 - Day 15 - Men's Final - Day Session - Chatrier"
    // Extract the 3rd segment (phase/round)
    const parts = evenement.split(' - ');
    if (parts.length >= 3) return parts[2].trim();
    return evenement;
  };
  const convertSessionToSlot = (session) => {
    if (!session) return '';
    if (session.toLowerCase().includes('day')) return 'DAY';
    if (session.toLowerCase().includes('evening') || session.toLowerCase().includes('night')) return 'NIGHT';
    return session;
  };
  const shortenCourt = (lieu) => {
    if (!lieu) return '';
    if (lieu.includes('Chatrier')) return 'Chatrier';
    if (lieu.includes('Lenglen')) return 'Lenglen';
    if (lieu.includes('Mathieu')) return 'Mathieu';
    if (lieu.includes('Outside')) return 'Annexe';
    return lieu;
  };
  const formatRGCategory = (cat) => {
    if (!cat) return '';
    if (cat === 'GOLD') return 'CAT OR';
    if (cat.startsWith('CATEGORIE ')) return `CAT ${cat.replace('CATEGORIE ', '')}`;
    if (cat === 'PLEIN TARIF') return 'PLEIN TARIF';
    return cat;
  };
  const RG_ACHAT_HEADERS = ['Date', 'Session', 'Round', 'Category', '# tickets', 'Access', 'Escalier', 'Row', 'Seats', 'Tribune', 'Court', 'Prix', 'Manager', 'Acheteur original', 'Nom Client', 'Date de naissance Client', 'Email Client'];
  const buildRGAchatRow = (t) => [
    t.date_evenement || '', convertSessionToSlot(t.session), extractRGRound(t.evenement),
    formatRGCategory(t.categorie), '', t.acces || '', t.escalier || '',
    t.rang || '', t.place || '', t.tribune || '', shortenCourt(t.lieu),
    t.prix || 0, '', '', t.nom_client || '', t.dob_client || '', t.mail_client || ''
  ];

  // Export data to CSV - simple and clean
  const handleExportCSV = (exportAll = true) => {
    const timestamp = new Date().toISOString().slice(0, 10);
    const isRG_export = currentProject?.toUpperCase().includes('ROLAN') || currentProject?.toUpperCase().includes('RG');
    
    // CSV helper functions
    const escape = (val) => `"${String(val || '').replace(/"/g, '""')}"`;
    const toCSV = (headers, rows) => {
      const headerLine = headers.map(escape).join(';');
      const dataLines = rows.map(row => row.map(escape).join(';'));
      return [headerLine, ...dataLines].join('\n');
    };
    const downloadCSV = (content, filename) => {
      const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    };

    // Helper: format clients array for export
    const getClientNoms = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.nom || '').join(' | ');
      return t.nom_client || '';
    };
    const getClientDDNs = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.dob || '').join(' | ');
      return '';
    };
    const getClientEmails = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.email || '').join(' | ');
      return t.mail_client || '';
    };

    // Helper: generate individual client columns (NOM 1, DDN 1, EMAIL 1, NOM 2, ...)
    const getMaxClients = (ticketsList) => {
      let max = 0;
      for (const t of ticketsList) {
        const n = t.clients?.length || t.qty || 1;
        if (n > max) max = n;
      }
      return max;
    };
    const buildClientHeaders = (maxClients) => {
      const headers = [];
      for (let i = 1; i <= maxClients; i++) {
        headers.push(`NOM ${i}`, `DDN ${i}`, `EMAIL ${i}`);
      }
      return headers;
    };
    const buildClientCells = (t, maxClients) => {
      const cells = [];
      for (let i = 0; i < maxClients; i++) {
        const c = t.clients?.[i];
        cells.push(c?.nom || '', c?.dob || '', c?.email || '');
      }
      return cells;
    };
    // RG: clients stacked in single cells with newlines (NOM, DDN, EMAIL)
    const getClientNomsStacked = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.nom || '').join('\n');
      return t.nom_client || '';
    };
    const getClientDDNsStacked = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.dob || '').join('\n');
      return '';
    };
    const getClientEmailsStacked = (t) => {
      if (t.clients?.length > 0) return t.clients.map(c => c.email || '').join('\n');
      return t.mail_client || '';
    };

    if (exportAll) {
      // Helper: format date_attribution ISO → DD/MM/YYYY HH:mm for export
      const fmtAttrib = (iso) => {
        if (!iso) return '';
        try {
          const d = new Date(iso);
          if (isNaN(d.getTime())) return iso;
          const pad = (n) => String(n).padStart(2, '0');
          return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        } catch { return iso; }
      };
      // Export ALL data - 3 files
      let achatHeaders, achatRows;
      if (isRG_export) {
        achatHeaders = RG_ACHAT_HEADERS;
        achatRows = achatTickets.map(buildRGAchatRow);
      } else {
        achatHeaders = ['MATCH', 'CATÉGORIE', 'E-MAIL DU COMPTE', 'PW DU COMPTE', 'SOURCE', 'REF DE VENTE', 'NOM CLIENT', 'MAIL CLIENT', 'PREUVE ENVOI', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'QTY', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
        achatRows = achatTickets.map(t => [
          t.evenement, t.categorie, t.email_compte, t.pw_compte || '', t.source,
          t.ref_vente || '', t.nom_client || '', t.mail_client || '', t.preuve_envoi || '',
          t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '', t.qty || 1,
          fmtAttrib(t.date_attribution),
          t.attribue ? 'Oui' : 'Non', t.statut || ''
        ]);
      }
      
      // VENTE export
      let venteHeaders, venteRows;
      if (isRG_export) {
        // RG: 3 colonnes NOM, DDN, EMAIL avec clients empilés (retour à la ligne dans la cellule)
        venteHeaders = ['REF DE VENTE', 'VENDU LE', 'PLATEFORME', 'MATCH', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'CATÉGORIE', 'QTY', 'PRIX', 'NOTE', 'NOM', 'DDN', 'EMAIL', 'PREUVE', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
        venteRows = venteTickets.map(t => [
          t.ref_vente, t.date_operation || '', t.source, t.evenement,
          t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '',
          t.categorie, t.qty || 1, t.prix || 0, t.note || '',
          getClientNomsStacked(t), getClientDDNsStacked(t), getClientEmailsStacked(t),
          t.preuve_url ? `${t.preuve_url}` : '',
          fmtAttrib(t.date_attribution),
          t.attribue ? 'Oui' : 'Non', t.statut || ''
        ]);
      } else {
        venteHeaders = ['REF DE VENTE', 'VENDU LE', 'PLATEFORME', 'MATCH', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'CATÉGORIE', 'QTY', 'PRIX', 'NOTE', 'NOM CLIENT', 'MAIL CLIENT', 'PREUVE', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
        venteRows = venteTickets.map(t => [
          t.ref_vente, t.date_operation || '', t.source, t.evenement,
          t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '',
          t.categorie, t.qty || 1, t.prix || 0, t.note || '', t.nom_client || '', t.mail_client || '',
          t.preuve_url ? `${t.preuve_url}` : '',
          fmtAttrib(t.date_attribution),
          t.attribue ? 'Oui' : 'Non', t.statut || ''
        ]);
      }
      
      const deltaHeaders = ['Événement', 'Date', 'Ville', 'Stocks'];
      const deltaRows = delta.map(d => {
        const stockStr = d.stocks ? Object.entries(d.stocks).map(([cat, val]) => `${cat}:${val}`).join(' | ') : '';
        return [d.evenement, d.date_evenement || '', d.ville || '', stockStr];
      });
      
      downloadCSV(toCSV(achatHeaders, achatRows), `YAS_ACHAT_${currentProject}_${timestamp}.csv`);
      setTimeout(() => downloadCSV(toCSV(venteHeaders, venteRows), `YAS_VENTE_${currentProject}_${timestamp}.csv`), 300);
      setTimeout(() => downloadCSV(toCSV(deltaHeaders, deltaRows), `YAS_DELTA_${currentProject}_${timestamp}.csv`), 600);
      
      toast.success(`3 fichiers exportés: ACHAT (${achatTickets.length}), VENTE (${venteTickets.length}), DELTA`);
    } else {
      // Export FILTERED data - based on active tab
      // Uses tableFilteredTickets which contains the actually filtered tickets from TicketTable
      let headers, rows, filename, count;
      
      // Helper: format date_attribution ISO → DD/MM/YYYY HH:mm for export
      const fmtAttrib = (iso) => {
        if (!iso) return '';
        try {
          const d = new Date(iso);
          if (isNaN(d.getTime())) return iso;
          const pad = (n) => String(n).padStart(2, '0');
          return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        } catch { return iso; }
      };
      
      // Use the filtered tickets from the table (includes column filters, status filters, etc.)
      const ticketsToExport = tableFilteredTickets.length > 0 ? tableFilteredTickets : 
        (activeTab === 'achat' ? filteredAchatTickets : 
         activeTab === 'vente' ? filteredVenteTickets : filteredAllTickets);
      
      // Add search filter to filename if present
      const filterSuffix = '_FILTRE';
      
      if (activeTab === 'achat') {
        const achatToExport = ticketsToExport.filter(t => t.type === 'ACHAT');
        if (isRG_export) {
          headers = RG_ACHAT_HEADERS;
          rows = achatToExport.map(buildRGAchatRow);
        } else {
          headers = ['MATCH', 'CATÉGORIE', 'E-MAIL DU COMPTE', 'PW DU COMPTE', 'SOURCE', 'REF DE VENTE', 'NOM CLIENT', 'MAIL CLIENT', 'PREUVE ENVOI', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'QTY', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
          rows = achatToExport.map(t => [
            t.evenement, t.categorie, t.email_compte, t.pw_compte || '', t.source,
            t.ref_vente || '', t.nom_client || '', t.mail_client || '', t.preuve_envoi || '',
            t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '', t.qty || 1,
            fmtAttrib(t.date_attribution),
            t.attribue ? 'Oui' : 'Non', t.statut || ''
          ]);
        }
        filename = `YAS_ACHAT${filterSuffix}_${currentProject}_${timestamp}.csv`;
        count = achatToExport.length;
      } else if (activeTab === 'vente') {
        const venteToExport = ticketsToExport.filter(t => t.type === 'VENTE');
        if (isRG_export) {
          headers = ['REF DE VENTE', 'VENDU LE', 'PLATEFORME', 'MATCH', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'CATÉGORIE', 'QTY', 'PRIX', 'NOTE', 'NOM', 'DDN', 'EMAIL', 'MAIL COMPTE (ACHAT)', 'PW COMPTE (ACHAT)', 'SOURCE ACHAT', 'PREUVE', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
          rows = venteToExport.map(t => [
            t.ref_vente, t.date_operation || '', t.source, t.evenement,
            t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '',
            t.categorie, t.qty || 1, t.prix || 0, t.note || '',
            getClientNomsStacked(t), getClientDDNsStacked(t), getClientEmailsStacked(t),
            t.linked_mail_du_compte || '', t.linked_pw_du_compte || '', t.linked_source_achat || '',
            t.preuve_url ? `${t.preuve_url}` : '',
            fmtAttrib(t.date_attribution),
            t.attribue ? 'Oui' : 'Non', t.statut || ''
          ]);
        } else {
          headers = ['REF DE VENTE', 'VENDU LE', 'PLATEFORME', 'MATCH', 'LIEU', 'VILLE', 'PAYS', 'DATE', 'CATÉGORIE', 'QTY', 'PRIX', 'NOTE', 'NOM CLIENT', 'MAIL CLIENT', 'MAIL COMPTE (ACHAT)', 'PW COMPTE (ACHAT)', 'SOURCE ACHAT', 'PREUVE', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
          rows = venteToExport.map(t => [
            t.ref_vente, t.date_operation || '', t.source, t.evenement,
            t.lieu || '', t.ville || '', t.pays || '', t.date_evenement || '',
            t.categorie, t.qty || 1, t.prix || 0, t.note || '', t.nom_client || '', t.mail_client || '',
            t.linked_mail_du_compte || '', t.linked_pw_du_compte || '', t.linked_source_achat || '',
            t.preuve_url ? `${t.preuve_url}` : '',
            fmtAttrib(t.date_attribution),
            t.attribue ? 'Oui' : 'Non', t.statut || ''
          ]);
        }
        filename = `YAS_VENTE${filterSuffix}_${currentProject}_${timestamp}.csv`;
        count = venteToExport.length;
      } else if (activeTab === 'tout') {
        headers = ['TYPE', 'MATCH', 'CATÉGORIE', 'DATE', 'QTY', 'PRIX', 'SOURCE', 'REF DE VENTE', 'VENDU LE', 'LIEU', 'VILLE', 'PAYS', 'NOTE', 'E-MAIL COMPTE', 'PW COMPTE', 'PREUVE ENVOI', 'PREUVE', 'NOM CLIENT', 'MAIL CLIENT', 'DATE ATTRIBUTION', 'ATTRIBUÉ', 'STATUT'];
        rows = ticketsToExport.map(t => [
          t.type, t.evenement, t.categorie, t.date_evenement || '', t.qty || 1, t.prix || 0, t.source,
          t.ref_vente || '', t.date_operation || '', t.lieu || '', t.ville || '', t.pays || '', t.note || '',
          t.email_compte || '', t.pw_compte || '', t.preuve_envoi || '',
          t.preuve_url ? `${t.preuve_url}` : '',
          t.nom_client || '', t.mail_client || '',
          fmtAttrib(t.date_attribution),
          t.attribue ? 'Oui' : 'Non', t.statut || ''
        ]);
        filename = `YAS_TOUT${filterSuffix}_${currentProject}_${timestamp}.csv`;
        count = ticketsToExport.length;
      } else {
        toast.error('Sélectionnez un onglet ACHAT, VENTE ou TOUT pour exporter');
        return;
      }
      
      downloadCSV(toCSV(headers, rows), filename);
      toast.success(`${count} lignes exportées (filtrées): ${filename}`);
    }
  };

  // Handle click on DELTA category - navigate to filtered view
  const handleDeltaCategoryClick = ({ viewType, eventName, matchNum, category, stock, session, lieu }) => {
    // Set delta filter and switch to the appropriate tab
    setDeltaFilter({ matchNum, category, eventName, stock, session, lieu });
    // Filter by NON-ATTRIBUTED tickets only (Delta shows available stock)
    setStatusFilter('non_attribue');
    // viewType est fourni explicitement par les boutons Voir VENTE / Voir STOCK du tooltip.
    // Fallback : déduit du signe du stock (négatif → vente, positif → achat).
    const tabName = viewType === 'vente' || viewType === 'achat'
      ? viewType
      : (stock < 0 ? 'vente' : 'achat');
    setActiveTabFromCard(tabName);
    toast.info(`Filtre: M${matchNum} - ${category} - ${tabName === 'vente' ? 'VENTE' : 'STOCK'}`);
  };

  // Clear delta filter and return to DELTA view
  const clearDeltaFilter = () => {
    setDeltaFilter(null);
    setActiveTab('delta');
  };

  // Helper to extract match number from event name
  const extractMatchNum = (eventName) => {
    if (!eventName) return null;
    const match = eventName.match(/\b[M]?0*(\d{1,3})\b/i);
    return match ? parseInt(match[1], 10) : null;
  };

  // Filter tickets based on status filter, delta filter, AND global search term
  const getFilteredTickets = (baseTickets) => {
    let result = baseTickets;
    
    // Apply status filter
    if (statusFilter) {
      if (statusFilter === 'attribue') {
        result = result.filter(t => t.attribue === true);
      } else if (statusFilter === 'non_attribue') {
        // Non attributed = NOT attribue AND NOT validated
        result = result.filter(t => t.attribue !== true && t.statut !== 'VALIDE');
      } else {
        result = result.filter(t => t.statut === statusFilter);
      }
    }
    
    // Apply delta filter (match number + category)
    if (deltaFilter) {
      // Function to normalize category for comparison
      // IMPORTANT: Keep special categories as-is, only normalize simple "CAT X" variants
      const normalizeCategory = (cat) => {
        if (!cat) return 'SANS CATEGORIE';
        const catUpper = cat.toUpperCase().trim();
        
        // KEEP special categories as-is (don't normalize them)
        const specialKeywords = ['EASY', 'ACCESS', 'WHEELCHAIR', 'SUPORTER', 'SUPPORTER', 
                                 'STANDAR', 'AMENITY', 'LEVEL', 'SIDELINE', 'SINGLES',
                                 'PITCH', 'BEST AVAILABLE', 'LOUNGE', 'HOSPITALITY',
                                 'UPPER', 'LOWER', '100-LEVEL', '200-LEVEL', '300-LEVEL', '400-LEVEL'];
        
        for (const keyword of specialKeywords) {
          if (catUpper.includes(keyword)) {
            return catUpper; // Return as-is, don't normalize
          }
        }
        
        // Handle placeholders
        if (['XXX', 'X', 'NA', 'N/A', '-'].includes(catUpper)) {
          return catUpper;
        }
        
        // Only normalize SIMPLE category names (CAT 1, CATEGORY 2, etc.)
        const simpleCatMatch = catUpper.match(/^(CAT|CATEGORY|CATEGORIE|CATÉGORIE)\s*(\d+)$/);
        if (simpleCatMatch) {
          return `CATEGORIE ${simpleCatMatch[2]}`;
        }
        
        // Handle "CAT1", "CAT2" without space
        const simpleCatMatch2 = catUpper.match(/^(CAT|CATEGORY|CATEGORIE|CATÉGORIE)(\d+)$/);
        if (simpleCatMatch2) {
          return `CATEGORIE ${simpleCatMatch2[2]}`;
        }
        
        // Handle VIP standalone
        if (catUpper === 'VIP') return 'VIP';
        
        // Handle numbered categories like "1", "2", "3" alone
        if (/^\d+$/.test(catUpper) && parseInt(catUpper) <= 10) {
          return `CATEGORIE ${catUpper}`;
        }
        
        return catUpper;
      };

      result = result.filter(t => {
        const ticketMatchNum = extractMatchNum(t.evenement);
        const matchesMatchNum = ticketMatchNum === deltaFilter.matchNum;
        
        // Pour Roland Garros: filtrer par nom de phase + session pour distinguer Day/Evening
        let matchesEvent = matchesMatchNum;
        if (deltaFilter.eventName && matchesMatchNum) {
          const evLower = (t.evenement || '').toLowerCase();
          const filterLower = deltaFilter.eventName.toLowerCase();
          
          // Check if ticket event contains the phase name from delta
          const phaseMatch = evLower.includes(filterLower);
          
          // Also check session if available (Day Session / Evening Session)
          const sessionStr = (deltaFilter.session || '').toLowerCase();
          if (sessionStr && sessionStr !== '-') {
            const isDay = sessionStr.includes('day');
            const isEvening = sessionStr.includes('evening') || sessionStr.includes('night');
            // Check BOTH ticket's session field AND event name for session info
            const ticketSession = (t.session || '').toLowerCase();
            const ticketIsExplicitDay = ticketSession.includes('day') || evLower.includes('day session');
            const ticketIsEvening = ticketSession.includes('evening') || ticketSession.includes('night') || evLower.includes('evening session') || evLower.includes('night session');
            // RG sessions are binary: Day or Evening. If no Evening marker → it's a Day match by default.
            const ticketIsDay = ticketIsExplicitDay || !ticketIsEvening;

            if (isDay) {
              matchesEvent = matchesMatchNum && ticketIsDay && !ticketIsEvening;
            } else if (isEvening) {
              matchesEvent = matchesMatchNum && ticketIsEvening && !ticketIsExplicitDay;
            } else {
              matchesEvent = phaseMatch || matchesMatchNum;
            }
          } else if (phaseMatch) {
            matchesEvent = true;
          }
        }
        
        // Normalize both categories for comparison
        const normalizedTicketCat = normalizeCategory(t.categorie);
        const normalizedFilterCat = normalizeCategory(deltaFilter.category);
        
        // Flexible category matching: exact match OR one contains the other
        // This handles ANNEXE/ANNEXES, and other singular/plural variations
        const matchesCategory = !deltaFilter.category || 
          deltaFilter.category === 'SANS CATEGORIE' || 
          normalizedTicketCat === normalizedFilterCat ||
          normalizedTicketCat.startsWith(normalizedFilterCat) ||
          normalizedFilterCat.startsWith(normalizedTicketCat);
        
        // Filter by lieu (court) if specified — Chatrier vs Lenglen
        // SPECIAL CASE: ANNEXE category is court-agnostic (valid on ANY annex court of the complex)
        const filterCatUpper = (deltaFilter.category || '').toUpperCase();
        const filterIsAnnexe = filterCatUpper.includes('ANNEXE');
        const filterLieu = (deltaFilter.lieu || '').toLowerCase();
        let matchesLieu = true;
        if (filterLieu && !filterIsAnnexe) {
          const ticketLieu = (t.lieu || '').toLowerCase();
          const ticketEv = (t.evenement || '').toLowerCase();
          const ticketCours = (t.cours || '').toLowerCase();
          // Combine all court-related fields for matching
          const ticketCourtInfo = `${ticketLieu} ${ticketEv} ${ticketCours}`;

          if (filterLieu.includes('chatrier')) {
            matchesLieu = ticketCourtInfo.includes('chatrier');
          } else if (filterLieu.includes('lenglen')) {
            matchesLieu = ticketCourtInfo.includes('lenglen');
          } else if (filterLieu.includes('outside') || filterLieu.includes('annexe')) {
            matchesLieu = ticketCourtInfo.includes('outside') || ticketCourtInfo.includes('annexe');
          } else {
            matchesLieu = ticketLieu.includes(filterLieu) || filterLieu.includes(ticketLieu);
          }
        }
        
        return matchesEvent && matchesCategory && matchesLieu;
      });
    }
    
    // NOTE: globalSearchTerm filtering is handled INSIDE TicketTable component
    // with more sophisticated logic (match number detection, etc.)
    // Do NOT filter here to avoid double-filtering
    
    return result;
  };

  const achatTickets = tickets.filter(t => t.type === 'ACHAT');
  const venteTickets = tickets.filter(t => t.type === 'VENTE');
  
  const filteredAllTickets = getFilteredTickets(tickets);
  const filteredAchatTickets = getFilteredTickets(achatTickets);
  const filteredVenteTickets = getFilteredTickets(venteTickets);

  // Filtered views for dedicated tabs (RG)
  // Group attributed tickets: VENTE + its LINKED ACHATs only
  const attribuesTickets = React.useMemo(() => {
    const attributed = tickets.filter(t => 
      t.attribue === true && t.statut !== 'VALIDE' && t.statut !== 'LIVRE'
    );
    
    const ventes = attributed.filter(t => t.type === 'VENTE');
    const achats = attributed.filter(t => t.type === 'ACHAT');
    
    const usedAchatIds = new Set();
    const grouped = [];
    const ventesWithoutAchats = [];
    
    for (const vente of ventes) {
      const venteRef = vente.ref_vente || '';
      const venteId = vente.id || '';
      const linkedAchats = achats.filter(a => {
        const aRef = a.ref_vente || '';
        return aRef && (aRef === venteRef || aRef === venteId);
      });
      
      if (linkedAchats.length > 0) {
        // Real group: VENTE + linked ACHATs
        grouped.push({ ...vente, _groupStart: true, _groupSize: 1 + linkedAchats.length });
        for (const a of linkedAchats) {
          grouped.push({ ...a, _inGroup: true });
          usedAchatIds.add(a.id);
        }
      } else {
        // VENTE without any linked ACHAT = problem
        ventesWithoutAchats.push({ ...vente, _orphan: true });
      }
    }
    
    // Orphan ACHATs (attributed but no matching VENTE)
    const orphanAchats = achats.filter(a => !usedAchatIds.has(a.id)).map(a => ({ ...a, _orphan: true }));
    
    // Append orphans: first broken VENTEs, then orphan ACHATs
    return [...grouped, ...ventesWithoutAchats, ...orphanAchats];
  }, [tickets]);

  const validesTickets = React.useMemo(() => {
    const validated = tickets.filter(t => t.statut === 'VALIDE');
    const ventes = validated.filter(t => t.type === 'VENTE');
    const achats = validated.filter(t => t.type === 'ACHAT');
    const usedAchatIds = new Set();
    const grouped = [];
    const broken = [];
    for (const vente of ventes) {
      const venteRef = vente.ref_vente || '';
      const venteId = vente.id || '';
      const linked = achats.filter(a => { const r = a.ref_vente || ''; return r && (r === venteRef || r === venteId); });
      if (linked.length > 0) {
        grouped.push({ ...vente, _groupStart: true, _groupSize: 1 + linked.length });
        for (const a of linked) { grouped.push({ ...a, _inGroup: true }); usedAchatIds.add(a.id); }
      } else { broken.push({ ...vente, _orphan: true }); }
    }
    return [...grouped, ...broken, ...achats.filter(a => !usedAchatIds.has(a.id)).map(a => ({ ...a, _orphan: true }))];
  }, [tickets]);

  const livresTickets = React.useMemo(() => {
    const livres = tickets.filter(t => t.statut === 'LIVRE');
    const ventes = livres.filter(t => t.type === 'VENTE');
    const achats = livres.filter(t => t.type === 'ACHAT');
    const usedAchatIds = new Set();
    const grouped = [];
    const broken = [];
    for (const vente of ventes) {
      const venteRef = vente.ref_vente || '';
      const venteId = vente.id || '';
      const linked = achats.filter(a => { const r = a.ref_vente || ''; return r && (r === venteRef || r === venteId); });
      if (linked.length > 0) {
        grouped.push({ ...vente, _groupStart: true, _groupSize: 1 + linked.length });
        for (const a of linked) { grouped.push({ ...a, _inGroup: true }); usedAchatIds.add(a.id); }
      } else { broken.push({ ...vente, _orphan: true }); }
    }
    return [...grouped, ...broken, ...achats.filter(a => !usedAchatIds.has(a.id)).map(a => ({ ...a, _orphan: true }))];
  }, [tickets]);

  // LITIGE tickets — VENTE first, then linked ACHATs (same pattern as attribues)
  const litigeTickets = React.useMemo(() => {
    const inLitige = tickets.filter(t => t.litige === true);
    const ventes = inLitige.filter(t => t.type === 'VENTE');
    const achats = inLitige.filter(t => t.type === 'ACHAT');
    const usedAchatIds = new Set();
    const grouped = [];
    const broken = [];
    for (const vente of ventes) {
      const venteRef = (vente.ref_vente || '').trim();
      const venteId = vente.id || '';
      const linked = achats.filter(a => {
        const r = (a.ref_vente || '').trim();
        return r && (r === venteRef || r === venteId);
      });
      if (linked.length > 0) {
        grouped.push({ ...vente, _groupStart: true, _groupSize: 1 + linked.length });
        for (const a of linked) { grouped.push({ ...a, _inGroup: true }); usedAchatIds.add(a.id); }
      } else {
        broken.push({ ...vente, _orphan: true });
      }
    }
    const orphanAchats = achats.filter(a => !usedAchatIds.has(a.id)).map(a => ({ ...a, _orphan: true }));
    return [...grouped, ...broken, ...orphanAchats];
  }, [tickets]);

  // ACTION REQUISE tickets — VENTE first, then linked ACHATs (same pattern as litige)
  const actionRequiseTickets = React.useMemo(() => {
    const flagged = tickets.filter(t => t.action_requise === true);
    const ventes = flagged.filter(t => t.type === 'VENTE');
    const achats = flagged.filter(t => t.type === 'ACHAT');
    const usedAchatIds = new Set();
    const grouped = [];
    const broken = [];
    for (const vente of ventes) {
      const venteRef = (vente.ref_vente || '').trim();
      const venteId = vente.id || '';
      const linked = achats.filter(a => {
        const r = (a.ref_vente || '').trim();
        return r && (r === venteRef || r === venteId);
      });
      if (linked.length > 0) {
        grouped.push({ ...vente, _groupStart: true, _groupSize: 1 + linked.length });
        for (const a of linked) { grouped.push({ ...a, _inGroup: true }); usedAchatIds.add(a.id); }
      } else {
        broken.push({ ...vente, _orphan: true });
      }
    }
    const orphanAchats = achats.filter(a => !usedAchatIds.has(a.id)).map(a => ({ ...a, _orphan: true }));
    return [...grouped, ...broken, ...orphanAchats];
  }, [tickets]);



  // Show loading while checking auth
  if (authChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0d0b09' }}>
        <div className="text-[#C4A052] text-xl">Chargement...</div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return (
      <>
        <Toaster richColors position="top-right" />
        <LoginPage onLogin={handleLogin} />
      </>
    );
  }

  // ÉCRAN DE TRANSITION - Changement de projet en cours
  if (projectSwitching || (loading && tickets.length === 0 && !stats)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: '#0d0b09' }}>
        <div className="w-full max-w-md text-center space-y-6">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#C4A052] border-t-transparent mx-auto"></div>
          <div className="text-[#C4A052] text-2xl font-bold">{currentProject}</div>
          {/* Barre de progression réelle (suit l'avancement des fetchs API) */}
          <div className="w-full" data-testid="boot-progress">
            <div className="relative h-2 w-full bg-zinc-800 rounded-full overflow-hidden ring-1 ring-zinc-700/50">
              <div
                className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#C4A052] via-[#d4b160] to-[#C4A052] rounded-full transition-[width] duration-300 ease-out shadow-[0_0_12px_rgba(196,160,82,0.6)]"
                style={{ width: `${Math.max(loadProgress, 5)}%` }}
              />
            </div>
            <div className="flex items-center justify-between mt-2 text-xs">
              <span className="text-zinc-400">Chargement des données…</span>
              <span className="text-[#C4A052] font-mono font-bold tabular-nums">{loadProgress}%</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Déterminer si on est sur Roland Garros pour le thème
  const isRolandGarros = currentProject?.toUpperCase().includes('ROLAN') || currentProject?.toUpperCase().includes('RG');
  const isWorldCup = (currentProject?.toUpperCase() || '').startsWith('WORLD CUP') || currentProject?.toUpperCase() === 'WC 2026';
  const isRugby = (currentProject?.toUpperCase() || '').includes('RUGBY');

  // URLs des assets par projet
  const projectThemes = {
    rolandGarros: {
      logo: 'https://customer-assets.emergentagent.com/job_02239018-f5c6-41eb-92ff-3437cce99ffb/artifacts/02ntrxea_image.png',
      background: 'https://images.pexels.com/photos/18213629/pexels-photo-18213629.jpeg?auto=compress&cs=tinysrgb&w=1920',
      titleColor: '#1B5E20',
    },
    worldCup: {
      logo: 'https://customer-assets.emergentagent.com/job_02239018-f5c6-41eb-92ff-3437cce99ffb/artifacts/0hu3mfvi_image.png',
      background: 'https://customer-assets.emergentagent.com/job_02239018-f5c6-41eb-92ff-3437cce99ffb/artifacts/hdjwo1rd_image.png',
      titleColor: '#C4A052',
    }
  };

  const hasCustomTheme = isRolandGarros || isWorldCup;
  const currentTheme = isRolandGarros ? projectThemes.rolandGarros : isWorldCup ? projectThemes.worldCup : null;

  return (
    <div className={`min-h-screen relative ${isRolandGarros ? 'rg-theme' : ''} ${isWorldCup ? 'wc-theme' : ''}`} style={{ backgroundColor: isDarkMode ? '#0d0b09' : '#f5f5f5' }}>
      {/* Fond thématique selon le projet */}
      {hasCustomTheme && currentTheme && (
        <div 
          className="fixed inset-0 z-0 pointer-events-none"
          style={{
            backgroundImage: `url('${currentTheme.background}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: isDarkMode ? 0.85 : 0.65,
          }}
        />
      )}
      
      {/* Overlay gradient pour lisibilité */}
      {hasCustomTheme && (
        <div 
          className="fixed inset-0 z-0 pointer-events-none"
          style={{
            background: isDarkMode 
              ? 'linear-gradient(180deg, rgba(13, 11, 9, 0.7) 0%, rgba(13, 11, 9, 0.3) 40%, rgba(13, 11, 9, 0.5) 100%)'
              : 'linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0.6) 100%)',
          }}
        />
      )}
      
      <div className="relative z-10">
        <Toaster richColors position="top-right" />
        
        {/* Header */}
        <header className={`glass-header sticky top-0 z-40 px-3 md:px-6 ${headerCollapsed ? 'py-1' : 'py-2 md:py-4'}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 md:gap-4 relative">
            {/* Logo selon le projet (Roland Garros, World Cup, ou YAS par défaut) */}
            {hasCustomTheme && currentTheme ? (
              <div 
                onClick={() => setShowProjectMenu(!showProjectMenu)}
                className="cursor-pointer flex items-center gap-2 md:gap-3"
              >
                <img 
                  src={currentTheme.logo} 
                  alt={currentProject}
                  className={headerCollapsed ? "h-7 w-auto object-contain" : "h-10 md:h-16 w-auto object-contain"}
                  style={{ maxHeight: headerCollapsed ? '28px' : '64px' }}
                />
              </div>
            ) : (
              <div 
                onClick={() => setShowProjectMenu(!showProjectMenu)}
                className="cursor-pointer"
              >
                <YASLogo />
              </div>
            )}
            <div className="flex flex-col cursor-pointer" onClick={() => setShowProjectMenu(!showProjectMenu)} data-testid="project-title-toggle" title="Changer de projet">
              <span 
                className={`${headerCollapsed ? 'text-sm' : 'text-sm md:text-xl'} font-bold tracking-wide hover:opacity-80 transition flex items-center gap-2`}
                style={{ color: currentTheme?.titleColor || '#C4A052' }}
              >
                <span
                  data-testid="project-color-dot"
                  className="inline-block h-2.5 w-2.5 md:h-3 md:w-3 rounded-full flex-shrink-0"
                  style={{ backgroundColor: getProjectColor(currentProject), boxShadow: `0 0 8px ${getProjectColor(currentProject)}` }}
                />
                {currentProject}
              </span>
              {!headerCollapsed && (
                <span className="text-zinc-500 text-[10px] md:text-xs hidden sm:block">{t('clickToChangeProject')}</span>
              )}
            </div>
            
            {/* Project Menu */}
            {showProjectMenu && (
              <div className="absolute top-full left-0 mt-2 bg-zinc-900 border border-[#C4A052]/30 rounded-lg shadow-xl z-50 min-w-[250px]">
                <div className="p-2">
                  <p className="text-xs text-zinc-400 px-2 pb-2">Choisir un projet :</p>
                  {projectsLoading ? (
                    <div className="text-center py-4 text-zinc-500">Chargement...</div>
                  ) : projects.length === 0 ? (
                    <div className="text-center py-4 text-zinc-500">Aucun projet</div>
                  ) : (
                    projects.map((proj) => (
                      <button
                        key={proj}
                        onClick={() => requestProjectChange(proj)}
                        className={`w-full flex items-center px-3 py-2 rounded text-sm transition-colors ${
                          currentProject === proj 
                            ? 'bg-[#C4A052] text-black font-semibold' 
                            : 'text-white hover:bg-zinc-800'
                        }`}
                      >
                      <span
                        className="inline-block h-2.5 w-2.5 rounded-full mr-2 flex-shrink-0"
                        style={{ backgroundColor: getProjectColor(proj) }}
                      />
                      <span className="flex-1 text-left truncate">{proj}</span>
                      {currentProject === proj && (
                        <span className="text-xs ml-2">✓ actif</span>
                      )}
                      {/* Bouton supprimer (sauf projet actif) */}
                      {currentProject !== proj && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteProject(proj);
                          }}
                          className="ml-2 p-1 rounded hover:bg-red-500/20 text-zinc-500 hover:text-red-400 transition-colors"
                          title="Supprimer ce projet"
                        >
                          <Trash2 className="h-3 w-3" />
                        </button>
                      )}
                    </button>
                  ))
                  )}
                  <hr className="my-2 border-zinc-700" />
                  <button
                    onClick={handleAddProject}
                    className="w-full text-left px-3 py-2 rounded text-sm text-[#C4A052] hover:bg-zinc-800 flex items-center gap-2"
                  >
                    <Plus className="h-4 w-4" />
                    Nouveau projet
                  </button>
                </div>
              </div>
            )}
          </div>
          
          <div className={headerCollapsed ? "hidden" : "hidden md:flex flex-col gap-2"}>
            <div className="flex items-center gap-3">
              {/* Email Sync avec mode AUTO */}
              <div className="flex items-center">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowInboxModal(true)}
                  data-testid="inbox-button"
                  className={`btn-shiny rounded-r-none border-r-0 ${
                    autoSyncEnabled 
                      ? 'border-blue-500/60 bg-blue-500/20 text-blue-400 hover:bg-blue-500 hover:text-black' 
                      : 'border-[#C4A052]/40 bg-[#C4A052]/20 text-[#C4A052] hover:bg-[#D4B86A] hover:text-black'
                  } transition-all duration-300`}
                >
                  {syncRunning ? (
                    <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                  ) : (
                    <Inbox className="h-4 w-4 mr-2" />
                  )}
                  {t('inbox')}
                  {autoSyncEnabled && (
                    <span className="ml-2 px-1.5 py-0.5 bg-blue-500 text-black text-xs rounded font-bold">
                      SYNC
                    </span>
                  )}
                </Button>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    data-testid="auto-sync-dropdown"
                    className={`rounded-l-none px-2 ${
                      autoSyncEnabled 
                        ? 'border-blue-500/60 bg-blue-500/20 text-blue-400 hover:bg-blue-500 hover:text-black' 
                        : 'border-[#C4A052]/40 bg-[#C4A052]/20 text-[#C4A052] hover:bg-[#D4B86A] hover:text-black'
                    } transition-all duration-300`}
                  >
                    <ChevronDown className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-64 bg-zinc-900 border-zinc-700">
                  <div className="px-3 py-2 border-b border-zinc-700">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-white">Sync Auto Emails</span>
                      <Button
                        size="sm"
                        onClick={toggleAutoSync}
                        data-testid="toggle-auto-sync"
                        className={`h-7 px-3 ${
                          autoSyncEnabled 
                            ? 'bg-blue-500 hover:bg-blue-600 text-black' 
                            : 'bg-zinc-700 hover:bg-zinc-600 text-zinc-300'
                        }`}
                      >
                        {autoSyncEnabled ? (
                          <>
                            <Pause className="h-3 w-3 mr-1" />
                            STOP
                          </>
                        ) : (
                          <>
                            <Play className="h-3 w-3 mr-1" />
                            START
                          </>
                        )}
                      </Button>
                    </div>
                    {lastSyncRun && (
                      <p className="text-xs text-zinc-400 mt-1">
                        Dernier check: {lastSyncRun.toLocaleTimeString('fr-FR')}
                      </p>
                    )}
                  </div>
                  <div className="px-3 py-2">
                    <p className="text-xs text-zinc-400 mb-2">Intervalle de vérification</p>
                    <div className="grid grid-cols-4 gap-1">
                      {[30, 60, 120, 300].map((secs) => (
                        <Button
                          key={secs}
                          size="sm"
                          onClick={() => setAutoSyncInterval(secs)}
                          className={`h-7 text-xs ${
                            autoSyncInterval === secs
                              ? 'bg-blue-500 text-black'
                              : 'bg-zinc-800 text-zinc-300 hover:bg-zinc-700'
                          }`}
                        >
                          {secs < 60 ? `${secs}s` : `${secs / 60}m`}
                        </Button>
                      ))}
                    </div>
                  </div>
                  {/* Manual sync button */}
                  <div className="px-3 py-2 border-t border-zinc-700">
                    <Button
                      size="sm"
                      onClick={() => handleAutoSync(false)}
                      disabled={syncRunning}
                      className="w-full bg-[#C4A052] hover:bg-[#D4B86A] text-black"
                    >
                      {syncRunning ? (
                        <RefreshCw className="h-3 w-3 mr-2 animate-spin" />
                      ) : (
                        <Mail className="h-3 w-3 mr-2" />
                      )}
                      Vérifier maintenant
                    </Button>
                    
                    {/* 🔄 BOUTON RE-SCAN COMPLET */}
                    <Button
                      size="sm"
                      onClick={handleForceRescan}
                      disabled={forceRescanRunning || syncRunning}
                      className="w-full mt-2 bg-amber-600 hover:bg-amber-500 text-white"
                    >
                      {forceRescanRunning ? (
                        <RefreshCw className="h-3 w-3 mr-2 animate-spin" />
                      ) : (
                        <RotateCcw className="h-3 w-3 mr-2" />
                      )}
                      Re-scan complet
                    </Button>
                    <p className="text-xs text-zinc-500 mt-1 text-center">
                      Vérifie tous les emails (même traités)
                    </p>
                  </div>
                  {autoSyncEnabled && (
                    <div className="px-3 py-2 bg-blue-500/10 border-t border-zinc-700">
                      <div className="flex items-center gap-2 text-blue-400 text-xs">
                        <Clock className="h-3 w-3 animate-pulse" />
                        <span>Prochain check dans {autoSyncInterval}s</span>
                      </div>
                      {(syncStats.newTickets > 0 || syncStats.updatedTickets > 0) && (
                        <div className="mt-1 text-xs text-zinc-400">
                          Session: {syncStats.newTickets} nouveau(x), {syncStats.updatedTickets} màj
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* ====== SERVER-SIDE 24/7 SYNC SECTION ====== */}
                  <div className="px-3 py-3 border-t-2 border-emerald-500/50 bg-gradient-to-b from-emerald-900/20 to-transparent">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
                      <span className="text-sm font-bold text-emerald-400">SYNC SERVEUR 24/7</span>
                    </div>
                    <p className="text-xs text-zinc-400 mb-3">
                      Actif même si vous fermez le navigateur
                    </p>
                    
                    {serverSyncStatus?.is_running ? (
                      <>
                        <div className="bg-emerald-500/20 border border-emerald-500/40 rounded-lg p-2 mb-2">
                          <div className="flex items-center justify-between">
                            <span className="text-emerald-400 text-xs font-medium">🟢 ACTIF</span>
                            <span className="text-emerald-300 text-xs">
                              Toutes les {serverSyncStatus.interval_display}
                            </span>
                          </div>
                          {serverSyncStatus.last_sync && (
                            <p className="text-xs text-zinc-400 mt-1">
                              Dernier sync: {new Date(serverSyncStatus.last_sync).toLocaleTimeString('fr-FR')}
                            </p>
                          )}
                          {serverSyncStatus.sync_count > 0 && (
                            <p className="text-xs text-zinc-500 mt-1">
                              Total syncs: {serverSyncStatus.sync_count}
                            </p>
                          )}
                        </div>
                        <Button
                          size="sm"
                          onClick={handleStopServerSync}
                          disabled={serverSyncLoading}
                          className="w-full bg-red-500/80 hover:bg-red-500 text-white"
                        >
                          {serverSyncLoading ? (
                            <RefreshCw className="h-3 w-3 mr-2 animate-spin" />
                          ) : (
                            <Pause className="h-3 w-3 mr-2" />
                          )}
                          Arrêter le Sync Serveur
                        </Button>
                      </>
                    ) : (
                      <>
                        <div className="bg-zinc-800/50 border border-zinc-700 rounded-lg p-2 mb-2">
                          <span className="text-zinc-400 text-xs">🔴 INACTIF</span>
                        </div>
                        <div className="space-y-2">
                          <p className="text-xs text-zinc-500">Intervalle:</p>
                          <div className="grid grid-cols-4 gap-1 mb-2">
                            {[1, 5, 15, 30].map((mins) => (
                              <Button
                                key={mins}
                                size="sm"
                                onClick={() => handleStartServerSync(mins)}
                                disabled={serverSyncLoading}
                                className="h-7 text-xs bg-emerald-600 hover:bg-emerald-500 text-white"
                              >
                                {mins}min
                              </Button>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
            
            <Button
              variant="outline"
              size="sm"
              onClick={fetchData}
              data-testid="refresh-button"
              className="btn-shiny border-[#C4A052]/40 bg-transparent hover:bg-[#D4B86A] hover:text-black hover:border-[#E5C97B] text-[#C4A052] transition-all duration-300"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              {t('refresh')}
            </Button>
            
            {/* Matcher avec mode AUTO */}
            <div className="flex items-center">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleRunMatching(false)}
                disabled={matcherRunning}
                data-testid="match-button"
                className={`btn-shiny rounded-r-none border-r-0 ${
                  autoMatcherEnabled 
                    ? 'border-emerald-500/60 bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500 hover:text-black' 
                    : 'border-[#C4A052]/40 bg-transparent text-[#C4A052] hover:bg-[#D4B86A] hover:text-black'
                } transition-all duration-300`}
              >
                {matcherRunning ? (
                  <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                ) : (
                  <Zap className="h-4 w-4 mr-2" />
                )}
                {t('autoMatch')}
                {autoMatcherEnabled && (
                  <span className="ml-2 px-1.5 py-0.5 bg-emerald-500 text-black text-xs rounded font-bold">
                    AUTO
                  </span>
                )}
              </Button>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    data-testid="auto-matcher-dropdown"
                    className={`rounded-l-none px-2 ${
                      autoMatcherEnabled 
                        ? 'border-emerald-500/60 bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500 hover:text-black' 
                        : 'border-[#C4A052]/40 bg-transparent text-[#C4A052] hover:bg-[#D4B86A] hover:text-black'
                    } transition-all duration-300`}
                  >
                    <ChevronDown className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56 bg-zinc-900 border-zinc-700">
                  <div className="px-3 py-2 border-b border-zinc-700">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-white">Mode AUTO</span>
                      <Button
                        size="sm"
                        onClick={toggleAutoMatcher}
                        data-testid="toggle-auto-matcher"
                        className={`h-7 px-3 ${
                          autoMatcherEnabled 
                            ? 'bg-emerald-500 hover:bg-emerald-600 text-black' 
                            : 'bg-zinc-700 hover:bg-zinc-600 text-zinc-300'
                        }`}
                      >
                        {autoMatcherEnabled ? (
                          <>
                            <Pause className="h-3 w-3 mr-1" />
                            STOP
                          </>
                        ) : (
                          <>
                            <Play className="h-3 w-3 mr-1" />
                            START
                          </>
                        )}
                      </Button>
                    </div>
                    {lastMatcherRun && (
                      <p className="text-xs text-zinc-400 mt-1">
                        Dernier: {lastMatcherRun.toLocaleTimeString('fr-FR')}
                      </p>
                    )}
                  </div>
                  <div className="px-3 py-2">
                    <p className="text-xs text-zinc-400 mb-2">Intervalle</p>
                    <div className="grid grid-cols-4 gap-1">
                      {[30, 60, 120, 300].map((secs) => (
                        <Button
                          key={secs}
                          size="sm"
                          onClick={() => setAutoMatcherInterval(secs)}
                          className={`h-7 text-xs ${
                            autoMatcherInterval === secs
                              ? 'bg-[#C4A052] text-black'
                              : 'bg-zinc-800 text-zinc-300 hover:bg-zinc-700'
                          }`}
                        >
                          {secs < 60 ? `${secs}s` : `${secs / 60}m`}
                        </Button>
                      ))}
                    </div>
                  </div>
                  {autoMatcherEnabled && (
                    <div className="px-3 py-2 bg-emerald-500/10 border-t border-zinc-700">
                      <div className="flex items-center gap-2 text-emerald-400 text-xs">
                        <Clock className="h-3 w-3 animate-pulse" />
                        <span>Prochain dans {autoMatcherInterval}s</span>
                      </div>
                    </div>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>

            {/* Attribution Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                  data-testid="attribution-dropdown-button"
                  className="btn-shiny border-[#C4A052]/40 bg-transparent hover:bg-[#D4B86A] hover:text-black hover:border-[#E5C97B] text-[#C4A052] transition-all duration-300"
                >
                  Attribution
                  <ChevronDown className="h-4 w-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56 bg-zinc-900 border-zinc-700">
                <DropdownMenuItem
                  onClick={handleRunMatching}
                  className="text-emerald-400 focus:text-emerald-400 focus:bg-emerald-500/10"
                >
                  <Zap className="h-4 w-4 mr-2" />
                  {t('autoAttribution')}
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={handleOpenMatcherFilterModal}
                  disabled={matcherRunning}
                  className="text-amber-400 focus:text-amber-400 focus:bg-amber-500/10"
                  data-testid="match-filtered-button"
                >
                  <Filter className="h-4 w-4 mr-2" />
                  {t('specialAttribution')}
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={handleDesattribuerAll}
                  className="text-red-400 focus:text-red-400 focus:bg-red-500/10"
                >
                  <X className="h-4 w-4 mr-2" />
                  {t('unattributeAll')}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            {/* Nouveau - sur ligne 1 */}
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                setEditingTicket(null);
                setShowFormModal(true);
              }}
              data-testid="new-ticket-button"
              className="btn-shiny border-[#C4A052]/40 bg-transparent hover:bg-[#D4B86A] hover:text-black hover:border-[#E5C97B] text-[#C4A052] transition-all duration-300"
            >
              <Plus className="h-4 w-4 mr-2" />
              {t('newTicket')}
            </Button>
            
            {/* Import Dropdown - sur ligne 1 */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  data-testid="import-dropdown-button"
                  className="btn-shiny bg-[#C4A052] hover:bg-[#E5C97B] text-black font-semibold transition-all duration-300"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  {t('import')}
                  <ChevronDown className="h-4 w-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem
                  data-testid="import-email-option"
                  onClick={() => setShowImportModal(true)}
                >
                  <Mail className="h-4 w-4 mr-2" />
                  Importer un Email
                </DropdownMenuItem>
                <DropdownMenuItem
                  data-testid="import-sheet-option"
                  onClick={() => setShowBulkImportModal(true)}
                >
                  <FileSpreadsheet className="h-4 w-4 mr-2" />
                  Importer depuis Sheets/Excel
                </DropdownMenuItem>
                <DropdownMenuItem
                  data-testid="smart-import-option"
                  onClick={() => setShowSmartImportModal(true)}
                  className="bg-[#C4A052]/20 border-l-2 border-[#C4A052]"
                >
                  <Zap className="h-4 w-4 mr-2 text-[#C4A052]" />
                  <span className="text-[#C4A052] font-medium">Import Intelligent CSV</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  data-testid="google-sheets-import-option"
                  onClick={() => setShowGoogleSheetsModal(true)}
                  className="bg-green-500/10 border-l-2 border-green-500"
                >
                  <FileSpreadsheet className="h-4 w-4 mr-2 text-green-500" />
                  <span className="text-green-400 font-medium">Import Google Sheets</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            </div>

            {/* Bouton Normaliser Matchs RG - uniquement pour Roland Garros */}
            {isRolandGarros && (
              <Button
                variant="outline"
                size="sm"
                data-testid="normalize-rg-btn"
                onClick={async () => {
                  if (!window.confirm('Normaliser les noms de matchs RG ?\nCette action corrigera automatiquement les noms mal écrits en utilisant la base de données du calendrier RG 2026.')) return;
                  try {
                    const res = await ticketService.normalizeRGMatches(currentProject);
                    toast.success(`Normalisation terminée : ${res.updated} corrigé(s), ${res.already_ok} déjà OK, ${res.no_match} non trouvé(s)`);
                    if (res.updated > 0) {
                      fetchTickets();
                    }
                  } catch (err) {
                    toast.error('Erreur lors de la normalisation');
                  }
                }}
                className="btn-shiny border-green-500/40 bg-transparent hover:bg-green-500 hover:text-black hover:border-green-400 text-green-400 transition-all duration-300"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Normaliser Matchs
              </Button>
            )}

            {/* Bouton Fix Noms Rugby - uniquement pour Rugby World Cup */}
            {isRugby && (
              <Button
                variant="outline"
                size="sm"
                data-testid="normalize-rugby-btn"
                onClick={async () => {
                  if (!window.confirm('Corriger les noms de matchs Rugby ?\nLes billets avec noms marketplace (Winner SF 1, Round of 16...) seront renommés avec le bon numéro officiel (M1-M52).')) return;
                  try {
                    const res = await ticketService.normalizeRugbyMatches(currentProject);
                    toast.success(`Correction terminée : ${res.updated} corrigé(s), ${res.already_ok} déjà OK, ${res.no_match} non trouvé(s)`);
                    if (res.updated > 0) {
                      fetchTickets();
                    }
                  } catch (err) {
                    toast.error('Erreur lors de la correction');
                  }
                }}
                className="btn-shiny border-green-500/40 bg-transparent hover:bg-green-500 hover:text-black hover:border-green-400 text-green-400 transition-all duration-300"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Fix Noms Rugby
              </Button>
            )}

            {/* Bouton MAJ Clients VENTE - uniquement pour Roland Garros */}
            {isRolandGarros && (
              <Button
                variant="outline"
                size="sm"
                data-testid="import-update-clients-btn"
                onClick={() => setShowMajClientsModal(true)}
                className="btn-shiny border-cyan-500/40 bg-transparent hover:bg-cyan-500 hover:text-black hover:border-cyan-400 text-cyan-400 transition-all duration-300"
              >
                <Users className="h-4 w-4 mr-2" />
                MAJ Clients
              </Button>
            )}

            {/* === LIGNE 2: Outils regroupés en dropdown === */}
            <div className="flex items-center gap-3 justify-end">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                  data-testid="tools-dropdown-button"
                  className="btn-shiny border-[#C4A052]/40 bg-transparent hover:bg-[#C4A052] hover:text-black hover:border-[#D4B86A] text-[#C4A052] transition-all duration-300"
                >
                  <Wrench className="h-4 w-4 mr-2" />
                  Outils
                  <ChevronDown className="h-4 w-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-zinc-900 border-[#C4A052]/30 w-60">
                <DropdownMenuItem data-testid="ai-match-button" onClick={() => setShowAiMatchModal(true)}>
                  <span className="mr-2">🤖</span>
                  <span className="text-[#C4A052] font-medium">Attribution IA</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="bulk-validate-button" onClick={() => setShowBulkValidateModal(true)}>
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span className="text-green-400 font-medium">{t('massDeliver')}</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="audit-livraisons-button" onClick={() => setShowAuditLivraisonsModal(true)}>
                  <ShieldAlert className="h-4 w-4 mr-2 text-red-400" />
                  <span className="text-red-400 font-medium">Audit Livraisons</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="update-placement-button" onClick={() => setShowUpdatePlacementModal(true)}>
                  <MapPin className="h-4 w-4 mr-2 text-[#C4A052]" />
                  <span className="text-[#C4A052] font-medium">MAJ Emplacements</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="check-doublons-button" onClick={() => setShowDoublonsModal(true)}>
                  <AlertTriangle className="h-4 w-4 mr-2 text-[#C4A052]" />
                  <span className="text-[#C4A052] font-medium">{t('duplicates')}</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="fix-anti-single-button" onClick={() => setShowAntiSingleModal(true)}>
                  <AlertTriangle className="h-4 w-4 mr-2 text-orange-400" />
                  <span className="text-orange-400 font-medium">Fix Anti-Single</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="check-refs-button" onClick={() => setShowRefCheckModal(true)}>
                  <Search className="h-4 w-4 mr-2 text-emerald-400" />
                  <span className="text-emerald-400 font-medium">Vérifier Réfs</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="mark-rocketposter-button" onClick={handleMarkRocketposter}>
                  <span className="mr-2">🚀</span>
                  <span className="text-purple-400 font-medium">Rocketposter</span>
                </DropdownMenuItem>
                {isWorldCup && (
                  <DropdownMenuItem data-testid="email-update-button" onClick={() => setShowEmailUpdateModal(true)}>
                    <Mail className="h-4 w-4 mr-2 text-pink-400" />
                    <span className="text-pink-400 font-medium">MAJ Emails</span>
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem data-testid="normalization-button" onClick={() => setShowNormalizationModal(true)}>
                  <ArrowRight className="h-4 w-4 mr-2 text-sky-400" />
                  <span className="text-sky-400 font-medium">Normaliser</span>
                </DropdownMenuItem>
                <DropdownMenuItem data-testid="source-phones-button" onClick={() => setShowSourcePhonesModal(true)}>
                  <Phone className="h-4 w-4 mr-2 text-emerald-400" />
                  <span className="text-emerald-400 font-medium">Sources</span>
                </DropdownMenuItem>
                {isRolandGarros && (
                  <DropdownMenuItem data-testid="bulk-seat-update-button" onClick={() => setShowBulkSeatModal(true)}>
                    <MapPin className="h-4 w-4 mr-2 text-cyan-400" />
                    <span className="text-cyan-400 font-medium">MAJ Places</span>
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
            </div>
          </div>

          {/* User & Logout - séparé à droite */}
          <div className="flex items-center gap-2 ml-4 pl-4 border-l border-[#C4A052]/30">
              {/* Toggle réduire/afficher la barre du haut */}
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleHeaderCollapsed}
                data-testid="header-collapse-toggle"
                title={headerCollapsed ? 'Afficher la barre' : 'Réduire la barre'}
                className="hidden md:flex text-[#C4A052] hover:text-[#D4B86A] hover:bg-[#C4A052]/10 px-2"
              >
                {headerCollapsed ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
                <span className="ml-1 text-[10px] uppercase tracking-wider">{headerCollapsed ? 'Afficher' : 'Réduire'}</span>
              </Button>
              {/* Mobile hamburger menu */}
              <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
                <SheetTrigger asChild>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="md:hidden text-[#C4A052] hover:text-[#D4B86A] hover:bg-[#C4A052]/10"
                    data-testid="mobile-menu-button"
                  >
                    <Menu className="h-5 w-5" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="bg-zinc-950 border-[#C4A052]/30 w-72 overflow-y-auto">
                  <SheetHeader>
                    <SheetTitle className="text-[#C4A052]">Menu</SheetTitle>
                  </SheetHeader>
                  <div className="flex flex-col gap-2 mt-4">
                    {/* Section: Email & Sync */}
                    <p className="text-xs text-zinc-500 uppercase tracking-wide px-1">Email & Sync</p>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { setShowInboxModal(true); setMobileMenuOpen(false); }}>
                      <Mail className="h-4 w-4 mr-2" /> Boîte Mail
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { fetchData(); setMobileMenuOpen(false); }}>
                      <RefreshCw className="h-4 w-4 mr-2" /> {t('refresh')}
                    </Button>
                    
                    {/* Section: Attribution */}
                    <p className="text-xs text-zinc-500 uppercase tracking-wide px-1 mt-3">Attribution</p>
                    <Button variant="outline" size="sm" className="justify-start border-emerald-500/30 text-emerald-400" onClick={() => { handleRunMatching(false); setMobileMenuOpen(false); }}>
                      <Zap className="h-4 w-4 mr-2" /> {t('autoMatch')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { handleRunMatching(); setMobileMenuOpen(false); }}>
                      <Zap className="h-4 w-4 mr-2" /> {t('autoAttribution')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-amber-500/30 text-amber-400" onClick={() => { handleOpenMatcherFilterModal(); setMobileMenuOpen(false); }}>
                      <Filter className="h-4 w-4 mr-2" /> {t('specialAttribution')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-red-500/30 text-red-400" onClick={() => { handleDesattribuerAll(); setMobileMenuOpen(false); }}>
                      <X className="h-4 w-4 mr-2" /> {t('unattributeAll')}
                    </Button>
                    
                    {/* Section: Créer & Importer */}
                    <p className="text-xs text-zinc-500 uppercase tracking-wide px-1 mt-3">Créer & Importer</p>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { setEditingTicket(null); setShowFormModal(true); setMobileMenuOpen(false); }}>
                      <Plus className="h-4 w-4 mr-2" /> {t('newTicket')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { setShowSmartImportModal(true); setMobileMenuOpen(false); }}>
                      <Zap className="h-4 w-4 mr-2" /> Import Intelligent CSV
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-green-500/30 text-green-400" onClick={() => { setShowGoogleSheetsModal(true); setMobileMenuOpen(false); }}>
                      <FileSpreadsheet className="h-4 w-4 mr-2" /> Import Google Sheets
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { setShowBulkImportModal(true); setMobileMenuOpen(false); }}>
                      <FileSpreadsheet className="h-4 w-4 mr-2" /> Import Sheets/Excel
                    </Button>
                    
                    {/* Section: Outils */}
                    <p className="text-xs text-zinc-500 uppercase tracking-wide px-1 mt-3">Outils</p>
                    <Button variant="outline" size="sm" className="justify-start border-green-500/30 text-green-400" onClick={() => { setShowBulkValidateModal(true); setMobileMenuOpen(false); }}>
                      <CheckCircle className="h-4 w-4 mr-2" /> {t('massDeliver')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-[#C4A052]/30 text-[#C4A052]" onClick={() => { setShowDoublonsModal(true); setMobileMenuOpen(false); }}>
                      <AlertTriangle className="h-4 w-4 mr-2" /> {t('duplicates')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-orange-500/30 text-orange-400" onClick={() => { setShowAntiSingleModal(true); setMobileMenuOpen(false); }}>
                      <AlertTriangle className="h-4 w-4 mr-2" /> Fix Anti-Single
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-emerald-500/30 text-emerald-400" onClick={() => { setShowRefCheckModal(true); setMobileMenuOpen(false); }}>
                      <Search className="h-4 w-4 mr-2" /> Vérifier Réfs
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-sky-500/30 text-sky-400" onClick={() => { setShowNormalizationModal(true); setMobileMenuOpen(false); }}>
                      <ArrowRight className="h-4 w-4 mr-2" /> Normaliser
                    </Button>
                    {isRolandGarros && (
                      <>
                        <Button variant="outline" size="sm" className="justify-start border-cyan-500/30 text-cyan-400" onClick={() => { setShowMajClientsModal(true); setMobileMenuOpen(false); }}>
                          <Users className="h-4 w-4 mr-2" /> MAJ Clients
                        </Button>
                      </>
                    )}
                    
                    {/* Section: Compte */}
                    <p className="text-xs text-zinc-500 uppercase tracking-wide px-1 mt-3">Compte</p>
                    <Button variant="outline" size="sm" className="justify-start border-zinc-600 text-zinc-300" onClick={() => { loadSnapshots(); setShowHistoryModal(true); setMobileMenuOpen(false); }}>
                      <History className="h-4 w-4 mr-2" /> {t('versionHistory')}
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start border-red-500/30 text-red-400" onClick={() => { handleLogout(); setMobileMenuOpen(false); }}>
                      <LogOut className="h-4 w-4 mr-2" /> {t('logout')}
                    </Button>
                  </div>
                </SheetContent>
              </Sheet>

              {/* Theme Toggle Button */}
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleTheme}
                className="text-[#C4A052] hover:text-[#D4B86A] hover:bg-[#C4A052]/10"
                title={isDarkMode ? t('lightMode') : t('darkMode')}
                data-testid="theme-toggle"
              >
                {isDarkMode ? (
                  <Sun className="h-5 w-5" />
                ) : (
                  <Moon className="h-5 w-5" />
                )}
              </Button>
              
              <span className="hidden md:inline"><LanguageSwitcher /></span>
              
              {/* Connected users avatars */}
              {connectedUsers.length > 0 && (
                <div className="hidden md:flex items-center -space-x-2" data-testid="connected-users">
                  {connectedUsers.map((u, i) => (
                    <div
                      key={i}
                      title={u.pseudo}
                      className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white border-2 border-zinc-900 shrink-0"
                      style={{ backgroundColor: u.color, zIndex: connectedUsers.length - i }}
                    >
                      {u.pseudo?.charAt(0)?.toUpperCase()}
                    </div>
                  ))}
                  <span className="text-xs text-zinc-500 pl-3">{connectedUsers.length} en ligne</span>
                </div>
              )}
              
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-[#C4A052] hover:text-[#D4B86A] hover:bg-[#C4A052]/10 flex items-center gap-2"
                  >
                    <User className="h-4 w-4" />
                    <span className="font-medium hidden md:inline">{userPseudo || userName}</span>
                    <ChevronDown className="h-3 w-3 hidden md:inline" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-zinc-900 border-[#C4A052]/30 w-56">
                  <DropdownMenuItem 
                    onClick={() => { loadSnapshots(); setShowHistoryModal(true); }}
                    className="cursor-pointer hover:bg-[#C4A052]/10 text-zinc-200"
                  >
                    <History className="h-4 w-4 mr-2 text-[#C4A052]" />
                    {t('versionHistory')}
                  </DropdownMenuItem>
                  <DropdownMenuItem 
                    onClick={() => setShowSystemHealth(true)}
                    className="cursor-pointer hover:bg-emerald-500/10 text-emerald-400"
                    data-testid="menu-server-health"
                  >
                    <Activity className="h-4 w-4 mr-2" />
                    {t('serverHealth')}
                  </DropdownMenuItem>
                  <DropdownMenuItem 
                    onClick={() => window.open(`/api/debug/download-logs`, '_blank')}
                    className="cursor-pointer hover:bg-blue-500/10 text-blue-400"
                  >
                    <Bug className="h-4 w-4 mr-2" />
                    {t('downloadLogs')}
                  </DropdownMenuItem>
                  <DropdownMenuItem 
                    onClick={handleLogout}
                    className="cursor-pointer hover:bg-red-500/10 text-red-400"
                  >
                    <LogOut className="h-4 w-4 mr-2" />
                    {t('logout')}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
          </div>
        </div>
      </header>

      {/* Notification banner - actions d'autres utilisateurs */}
      {notifications.length > 0 && (
        <div className="sticky top-0 z-40 bg-amber-500/10 border-b border-amber-500/40 px-4 py-2 flex items-center justify-between" data-testid="notification-banner">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <Bell className="w-4 h-4 text-amber-400 shrink-0" />
            <div className="text-sm text-amber-300 truncate">
              {notifications.length === 1 ? (
                <span><strong>{notifications[0].by}</strong> {notifications[0].action}</span>
              ) : (
                <span><strong>{notifications.length} modifications</strong> par {[...new Set(notifications.map(n => n.by))].join(', ')}</span>
              )}
            </div>
          </div>
          <div className="flex gap-2 shrink-0 ml-3">
            <Button size="sm" onClick={handleRefreshFromNotification} className="bg-amber-500 hover:bg-amber-600 text-black text-xs h-7 px-3" data-testid="notification-refresh-btn">
              Actualiser
            </Button>
            <Button size="sm" variant="ghost" onClick={clearNotifications} className="text-amber-400 hover:text-amber-300 text-xs h-7 px-2" data-testid="notification-dismiss-btn">
              Fermer
            </Button>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className="p-3 md:p-6 space-y-4 md:space-y-6">
        {/* Stats - Sticky right under the header */}
        <div className={`sticky ${headerCollapsed ? 'top-[40px]' : 'top-[88px] md:top-[110px]'} z-30 glass-header -mx-3 md:-mx-6 px-3 md:px-6 py-3 md:py-4 border-b border-zinc-800/60`}>
          <StatsCards stats={stats} project={currentProject} onTabChange={setActiveTabFromCard} onFilter={setStatusFilter} />
        </div>

        {/* Active Filter Indicator - Status */}
        {statusFilter && (
          <div className="flex items-center gap-2 bg-blue-500/20 border border-blue-500/30 rounded-lg px-4 py-2">
            <span className="text-blue-300 text-sm">
              Filtre actif: <strong>{
                statusFilter === 'attribue' ? 'Attribués' : 
                statusFilter === 'non_attribue' ? 'Non attribués' :
                statusFilter === 'VALIDE' ? 'Livrés' :
                statusFilter === 'ANNULEE' ? 'Annulés' :
                statusFilter === 'PENDING' ? 'En attente' :
                statusFilter === 'SPECIAL_MATCH' ? 'Attribution spéciale' :
                statusFilter
              }</strong>
            </span>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => setStatusFilter(null)}
              className="text-blue-300 hover:bg-blue-500/20 h-6 px-2"
            >
              ✕ Effacer
            </Button>
          </div>
        )}

        {/* Active Delta Filter Indicator */}
        {deltaFilter && (
          <div className="space-y-2">
            <div className="flex items-center gap-2 bg-[#C4A052]/20 border border-[#C4A052]/30 rounded-lg px-4 py-2">
              <span className="text-[#C4A052] text-sm">
                Filtre DELTA: <strong>M{deltaFilter.matchNum} - {deltaFilter.category}</strong>
                {deltaFilter.session && <span className="text-zinc-400 ml-1">({deltaFilter.session})</span>}
                {deltaFilter.lieu && <span className="text-zinc-400 ml-1">· {deltaFilter.lieu}</span>}
                <span className={deltaFilter.stock > 0 ? 'text-emerald-400' : 'text-red-400'}>
                  {' '}({deltaFilter.stock > 0 ? '+' : ''}{deltaFilter.stock})
                </span>
              </span>
              <Button
                size="sm"
                variant="ghost"
                onClick={clearDeltaFilter}
                data-testid="clear-delta-filter"
                className="text-[#C4A052] hover:bg-[#C4A052]/20 h-6 px-2"
              >
                ✕ Retour au {deltaViewMode === 'table' ? 'DRIVE' : 'DELTA'}
              </Button>
            </div>

            {/* Récap intelligent Delta */}
            {(() => {
              const isCancelled = (t) => {
                const s = (t.statut || '').toUpperCase();
                return s === 'ANNULEE' || s === 'ANNULÉ' || s === 'ANNULE';
              };
              const deltaVentes = filteredVenteTickets.filter(t => {
                const mNum = t.evenement?.match(/M?(\d+)/)?.[1];
                return mNum === String(deltaFilter.matchNum) && !isCancelled(t);
              });
              const deltaAchats = filteredAchatTickets.filter(t => {
                const mNum = t.evenement?.match(/M?(\d+)/)?.[1];
                return mNum === String(deltaFilter.matchNum) && !t.attribue && !isCancelled(t);
              });
              
              const totalVenteQty = deltaVentes.reduce((sum, t) => sum + (parseInt(t.qty, 10) || 1), 0);
              const totalAchatQty = deltaAchats.reduce((sum, t) => sum + (parseInt(t.qty, 10) || 1), 0);
              const manque = totalVenteQty - totalAchatQty;
              
              const venteDetails = deltaVentes.map(t => parseInt(t.qty, 10) || 1);

              return (totalVenteQty > 0 || totalAchatQty > 0) ? (
                <div className="bg-zinc-800/80 border border-zinc-700 rounded-lg px-4 py-3" data-testid="delta-recap">
                  <div className="flex items-center gap-4 flex-wrap">
                    <div>
                      <span className="text-red-400 text-sm">VENTES: {totalVenteQty} billet{totalVenteQty > 1 ? 's' : ''} à fournir</span>
                      {venteDetails.length > 0 && (
                        <span className="text-red-300 text-2xl font-black ml-2">({venteDetails.join(' + ')})</span>
                      )}
                    </div>
                    <div>
                      <span className="text-emerald-400 text-sm">
                        ACHAT en stock: {totalAchatQty} billet{totalAchatQty > 1 ? 's' : ''} disponible{totalAchatQty > 1 ? 's' : ''}
                      </span>
                    </div>
                    {manque > 0 && (
                      <div className="bg-red-500/15 border border-red-500/40 rounded-lg px-3 py-1">
                        <span className="text-red-300 text-sm font-bold">
                          IL MANQUE {manque} BILLET{manque > 1 ? 'S' : ''} {deltaFilter.category} À ACHETER
                        </span>
                      </div>
                    )}
                    {manque <= 0 && totalVenteQty > 0 && (
                      <div className="bg-emerald-500/15 border border-emerald-500/40 rounded-lg px-3 py-1">
                        <span className="text-emerald-300 text-sm">
                          STOCK OK ({totalAchatQty - totalVenteQty >= 0 ? '+' : ''}{totalAchatQty - totalVenteQty} surplus)
                        </span>
                      </div>
                    )}
                  </div>
                  {manque > 0 && (
                    <p className="text-sm text-yellow-400 mt-2 font-bold">
                      MAIS VÉRIFIER LE DISPATCH AVANT D'ACHETER 🚨
                    </p>
                  )}
                </div>
              ) : null;
            })()}
          </div>
        )}

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={(v) => { 
          setActiveTab(v); 
          // Only clear filters on manual tab click, not programmatic change from KPI cards
          if (!programmaticTabChange.current) {
            setStatusFilter(null); 
            setDeltaFilter(null); 
            setRecapDeltaFilter(null); 
          }
          programmaticTabChange.current = false;
        }} className="space-y-6">
          <TabsList className="bg-[#121212] border border-[#C4A052]/30 p-1 h-auto flex flex-nowrap overflow-x-auto scrollbar-thin">
            <TabsTrigger
              value="tout"
              data-testid="tab-tout"
              className="data-[state=active]:bg-[#C4A052] data-[state=active]:text-black px-4 py-2 font-semibold text-white"
            >
              <LayoutGrid className="h-4 w-4 mr-2" />
              {t('all')}
            </TabsTrigger>
            <TabsTrigger
              value="achat"
              data-testid="tab-achat"
              className="data-[state=active]:bg-emerald-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
            >
              <ShoppingCart className="h-4 w-4 mr-2" />
              {t('purchase')} ({stats?.total_achats || achatTickets.length})
            </TabsTrigger>
            <TabsTrigger
              value="vente"
              data-testid="tab-vente"
              className="data-[state=active]:bg-red-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
            >
              <TrendingUp className="h-4 w-4 mr-2" />
              {t('sale')} ({stats?.total_ventes || venteTickets.length})
            </TabsTrigger>
            {/* Onglets dédiés RG: ATTRIBUÉS, VALIDÉS, LIVRÉS */}
            {isRolandGarros && (
              <>
                <TabsTrigger
                  value="attribues"
                  data-testid="tab-attribues"
                  className="data-[state=active]:bg-blue-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
                >
                  <Link2 className="h-4 w-4 mr-2" />
                  ATTRIBUÉS ({attribuesTickets.length})
                </TabsTrigger>
                <TabsTrigger
                  value="valides"
                  data-testid="tab-valides"
                  className="data-[state=active]:bg-emerald-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
                >
                  <CheckCircle className="h-4 w-4 mr-2" />
                  VALIDÉS ({validesTickets.length})
                </TabsTrigger>
                <TabsTrigger
                  value="livres"
                  data-testid="tab-livres"
                  className="data-[state=active]:bg-orange-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
                >
                  <Ticket className="h-4 w-4 mr-2" />
                  LIVRÉS ({livresTickets.length})
                </TabsTrigger>
              </>
            )}
            <TabsTrigger
              value="comptes"
              data-testid="tab-comptes"
              className="data-[state=active]:bg-blue-500 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
            >
              <User className="h-4 w-4 mr-2" />
              {t('accounts')}
            </TabsTrigger>
            <TabsTrigger
              value="log"
              data-testid="tab-log"
              className="data-[state=active]:bg-[#C4A052] data-[state=active]:text-black px-4 py-2 font-semibold text-white"
            >
              <FileText className="h-4 w-4 mr-2" />
              LOG
            </TabsTrigger>
            <TabsTrigger
              value="mapping"
              data-testid="tab-mapping"
              className="data-[state=active]:bg-[#C4A052] data-[state=active]:text-black px-4 py-2 font-semibold text-white"
            >
              <Settings className="h-4 w-4 mr-2" />
              MAPPING STADE
            </TabsTrigger>
            <TabsTrigger
              value="backups"
              data-testid="tab-backups"
              className="data-[state=active]:bg-emerald-600 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
            >
              <Archive className="h-4 w-4 mr-2" />
              BACKUPS
            </TabsTrigger>
            <TabsTrigger
              value="market"
              data-testid="tab-market"
              className="data-[state=active]:bg-purple-600 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
            >
              <TrendingUp className="h-4 w-4 mr-2" />
              RECAP DELTA
            </TabsTrigger>
            
            {/* Onglet GROUPES - uniquement pour World Cup */}
            {isWorldCup && (
              <TabsTrigger
                value="groups"
                data-testid="tab-groups"
                className="data-[state=active]:bg-blue-600 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
              >
                ⚽ GROUPES
              </TabsTrigger>
            )}
            
            {/* Onglet MATCHS RG - uniquement pour Roland Garros */}
            {isRolandGarros && (
              <TabsTrigger
                value="rg-matches"
                data-testid="tab-rg-matches"
                className="data-[state=active]:bg-green-700 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
              >
                <FileSpreadsheet className="h-4 w-4 mr-2" />
                MATCHS RG
              </TabsTrigger>
            )}

            {/* Onglet AUDIT QUOTA RG - uniquement pour Roland Garros */}
            {isRolandGarros && (
              <TabsTrigger
                value="audit-quota"
                data-testid="tab-audit-quota"
                className="data-[state=active]:bg-red-700 data-[state=active]:text-white px-4 py-2 font-semibold text-white"
              >
                <AlertTriangle className="h-4 w-4 mr-2" />
                AUDIT 4 BILLETS
              </TabsTrigger>
            )}

            {/* Onglet AIDE LISTING */}
            <TabsTrigger
              value="aide-listing"
              data-testid="tab-aide-listing"
              className="data-[state=active]:bg-[#C4A052] data-[state=active]:text-black px-4 py-2 font-semibold text-white"
            >
              <MapPin className="h-4 w-4 mr-2" />
              AIDE LISTING
            </TabsTrigger>

            {/* Onglet LITIGE (violet) — tickets manuellement marqués en dispute */}
            <TabsTrigger
              value="litige"
              data-testid="tab-litige"
              className="data-[state=active]:bg-purple-600 data-[state=active]:text-white px-4 py-2 font-semibold text-purple-200 border-l border-purple-500/20"
            >
              <AlertTriangle className="h-4 w-4 mr-2" />
              LITIGE{litigeTickets.length > 0 ? ` (${litigeTickets.length})` : ''}
            </TabsTrigger>

            {/* Onglets GROUPES + PHASE FINALE — uniquement projet WORLD CUP 2026 */}
            {isWorldCup && (
              <>
                {/* Onglet GROUPES (vert) — World Cup 2026 classements + live scores */}
                <TabsTrigger
                  value="groupes"
                  data-testid="tab-groupes"
                  className="data-[state=active]:bg-emerald-600 data-[state=active]:text-white px-4 py-2 font-semibold text-emerald-200 border-l border-emerald-500/20"
                >
                  🏆 GROUPES
                </TabsTrigger>

                {/* Onglet PHASE FINALE (ambre) — bracket complet 1/16 → finale */}
                <TabsTrigger
                  value="phase-finale"
                  data-testid="tab-phase-finale"
                  className="data-[state=active]:bg-amber-600 data-[state=active]:text-white px-4 py-2 font-semibold text-amber-200 border-l border-amber-500/20"
                >
                  🥇 PHASE FINALE
                </TabsTrigger>
              </>
            )}

            {/* Onglet ACTION REQUISE (jaune) — tickets nécessitant une action manuelle */}
            <TabsTrigger
              value="action-requise"
              data-testid="tab-action-requise"
              className="data-[state=active]:bg-yellow-500 data-[state=active]:text-black px-4 py-2 font-semibold text-yellow-200 border-l border-yellow-500/20"
            >
              <AlertTriangle className="h-4 w-4 mr-2" />
              ACTION REQUISE{actionRequiseTickets.length > 0 ? ` (${actionRequiseTickets.length})` : ''}
            </TabsTrigger>

            {/* Onglet PARTIELS (bleu ciel) - visible si au moins 1 attribution partielle */}
            {(stats?.partial_ventes_count || 0) > 0 && (
              <TabsTrigger
                value="partials"
                data-testid="tab-partials"
                className="data-[state=active]:bg-sky-500 data-[state=active]:text-white px-4 py-2 font-semibold text-sky-200 border-l border-sky-500/20"
              >
                ⚡ PARTIELS ({stats.partial_ventes_count})
              </TabsTrigger>
            )}
            
            {/* Export Dropdown - Gold style */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  data-testid="export-dropdown-button"
                  className="ml-4 bg-[#C4A052] hover:bg-[#D4B86A] text-black font-semibold px-4 py-2"
                >
                  <Download className="h-4 w-4 mr-2" />
                  EXPORTER
                  <ChevronDown className="h-4 w-4 ml-2" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-64 bg-zinc-900 border-zinc-700">
                <DropdownMenuItem
                  onClick={() => handleExportCSV(true)}
                  className="text-white focus:text-white focus:bg-[#C4A052]/20"
                >
                  <Download className="h-4 w-4 mr-2 text-[#C4A052]" />
                  <div className="flex flex-col">
                    <span className="font-medium">Exporter TOUT</span>
                    <span className="text-xs text-zinc-400">3 fichiers CSV (ACHAT, VENTE, DELTA)</span>
                  </div>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => handleExportCSV(false)}
                  className="text-white focus:text-white focus:bg-[#C4A052]/20"
                >
                  <Filter className="h-4 w-4 mr-2 text-blue-400" />
                  <div className="flex flex-col">
                    <span className="font-medium">Exporter Onglet Actif</span>
                    <span className="text-xs text-zinc-400">Export de l'onglet {activeTab.toUpperCase()}</span>
                  </div>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </TabsList>

          {/* Bouton Retour RECAP DELTA si filtre actif */}
          {recapDeltaFilter && (
            <div className="flex items-center gap-4 p-3 bg-purple-500/10 border border-purple-500/30 rounded-lg">
              <span className="text-purple-400">
                🔍 Filtre RECAP DELTA : <span className="font-bold text-white">{recapDeltaFilter.match}</span> - <span className="text-zinc-400">{recapDeltaFilter.category}</span>
                {recapDeltaFilter.session && <span className="text-blue-400 ml-1">({recapDeltaFilter.session})</span>}
                <span className="ml-2 text-amber-400">(non attribués)</span>
              </span>
              <Button
                size="sm"
                onClick={() => {
                  setRecapDeltaFilter(null);
                  setGlobalSearchTerm('');
                  setStatusFilter(null);
                  setDeltaFilter(null);
                  setActiveTab('market');
                }}
                className="bg-purple-600 hover:bg-purple-700 text-white"
              >
                ← Retour RECAP DELTA
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => {
                  setRecapDeltaFilter(null);
                  setGlobalSearchTerm('');
                  setStatusFilter(null);
                  setDeltaFilter(null);
                }}
                className="border-zinc-600 text-zinc-400 hover:text-white"
              >
                ✕ Effacer filtre
              </Button>
            </div>
          )}

          <TabsContent value="tout" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={filteredAllTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="tout"
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isLightMode={!isDarkMode}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          <TabsContent value="achat" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={filteredAchatTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="achat"
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isLightMode={!isDarkMode}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          <TabsContent value="vente" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={filteredVenteTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onToggleLitige={handleToggleLitige}
              onToggleActionRequise={handleToggleActionRequise}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              loading={loading}
              viewType="vente"
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          {/* ATTRIBUÉS - Vue regroupée ACHAT + VENTE attribués */}
          <TabsContent value="attribues" className="mt-6 animate-fade-in">
            {/* Récap ACHAT - Roland Garros only */}
            {currentProject === 'ROLAND GARROS' && <RecapAchatToggle tickets={tickets} project={currentProject} />}
            <TicketTable
              tickets={attribuesTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="tout"
              presorted={true}
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          {/* VALIDÉS - Billets validés */}
          <TabsContent value="valides" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={validesTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="tout"
              presorted={true}
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          {/* LIVRÉS - Billets livrés */}
          <TabsContent value="livres" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={livresTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="tout"
              presorted={true}
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          <TabsContent value="delta" className="mt-6 animate-fade-in">
            <DeltaView data={delta} onCategoryClick={handleDeltaCategoryClick} project={currentProject} viewMode={deltaViewMode} onViewModeChange={setDeltaViewMode} allTickets={tickets} />
          </TabsContent>

          <TabsContent value="comptes" className="mt-6 animate-fade-in">
            <AccountsView 
              tickets={tickets} 
              onAccountClick={(email) => {
                setSelectedAccountFilter(email);
                setGlobalSearchTerm(email); // Met le filtre de recherche global
                setActiveTab('vente'); // Aller vers VENTE pour voir les ventes liées à ce compte
              }}
              selectedAccount={selectedAccountFilter}
              onRefresh={fetchData}
            />
          </TabsContent>

          <TabsContent value="log" className="mt-6 animate-fade-in">
            <LogView logs={logs} onClear={handleClearLogs} loading={loading} />
          </TabsContent>

          <TabsContent value="mapping" className="mt-6 animate-fade-in">
            <StadiumMappingView tickets={tickets} project={currentProject} />
          </TabsContent>

          <TabsContent value="backups" className="mt-6 animate-fade-in">
            <BackupsView currentProject={currentProject} onDataRefresh={fetchData} />
          </TabsContent>

          <TabsContent value="market" className="mt-6 animate-fade-in">
            <MarketEvolutionView 
              currentProject={currentProject} 
              onFilterClick={(filter) => {
                // IMPORTANT: Vider la barre de recherche EN PREMIER pour éviter le double filtrage
                setGlobalSearchTerm('');
                
                // Sauvegarder le filtre pour l'affichage
                setRecapDeltaFilter(filter);
                
                // Extraire le numéro de match (M14 → 14)
                const matchNumMatch = filter.match?.match(/M(\d+)/i);
                const matchNum = matchNumMatch ? parseInt(matchNumMatch[1], 10) : null;
                
                // Utiliser le deltaFilter existant (filtre par match + catégorie + session)
                setDeltaFilter({
                  matchNum: matchNum,
                  category: filter.category || null,
                  eventName: filter.event || null,
                  session: filter.session || null
                });
                
                // Filtrer sur non attribués
                setStatusFilter('non_attribue');
                
                // Aller dans le bon onglet selon le type
                // ACHETER (buy) = manque de ventes → aller dans VENTE
                // VENDRE (sell) = surplus stock → aller dans ACHAT
                if (filter.type === 'buy') {
                  setActiveTabFromCard('vente');
                } else {
                  setActiveTabFromCard('achat');
                }
              }}
            />
          </TabsContent>

          {/* Onglet GROUPES World Cup */}
          {isWorldCup && (
            <TabsContent value="groups" className="mt-0">
              <WorldCupGroupsView 
                onTeamClick={(team) => {
                  // Filtrer les tickets par équipe
                  setGlobalSearchTerm(team.name);
                  setActiveTab('achat');
                }}
              />
            </TabsContent>
          )}

          {/* Onglet MATCHS RG */}
          {isRolandGarros && (
            <TabsContent value="rg-matches" className="mt-0">
              <RGMatchesView project={currentProject} />
            </TabsContent>
          )}

          <TabsContent value="aide-listing" className="mt-0">
            <AideListingView tickets={tickets} project={currentProject} loading={loading} />
          </TabsContent>

          {/* Onglet LITIGE — tickets manuellement marqués en litige (VENTE first + linked ACHATs) */}
          <TabsContent value="litige" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={litigeTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onToggleLitige={handleToggleLitige}
              onToggleActionRequise={handleToggleActionRequise}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="litige"
              presorted={true}
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>

          {/* Onglets GROUPES + PHASE FINALE — uniquement projet WORLD CUP 2026 */}
          {isWorldCup && (
            <>
              {/* Onglet GROUPES — World Cup 2026 classements + live scores via api-football */}
              <TabsContent value="groupes" className="mt-6 animate-fade-in">
                <GroupsView />
              </TabsContent>

              {/* Onglet PHASE FINALE — bracket complet 1/16 → finale */}
              <TabsContent value="phase-finale" className="mt-6 animate-fade-in">
                <FinalBracketView />
              </TabsContent>
            </>
          )}

          {/* Onglet ACTION REQUISE — tickets manuellement flaggés en jaune (VENTE first + linked ACHATs) */}
          <TabsContent value="action-requise" className="mt-6 animate-fade-in">
            <TicketTable
              tickets={actionRequiseTickets}
              onUnmatch={handleUnmatch}
              onDelete={handleDelete}
              onBulkDelete={handleBulkDelete}
              onEdit={handleEdit}
              onUpdateStatus={handleUpdateStatus}
              onMarkAttribue={handleMarkAttribue}
              onValidateTicket={handleValidateTicket}
              onUnvalidate={handleUnvalidate}
              onMarkLivre={handleMarkLivre}
              onAttribuerVente={handleAttribuerVente}
              onUpdateClients={handleUpdateClients}
              onBulkUpdated={handleBulkUpdated}
              onToggleLitige={handleToggleLitige}
              onToggleActionRequise={handleToggleActionRequise}
              onOpenProofModal={(ticket) => {
                setProofTicket(ticket);
                setShowProofModal(true);
              }}
              onOpenProofEnvoiModal={(ticket) => {
                setProofEnvoiTicket(ticket);
                setShowProofEnvoiModal(true);
              }}
              loading={loading}
              viewType="action-requise"
              presorted={true}
              isLightMode={!isDarkMode}
              globalSearchTerm={globalSearchTerm}
              onSearchTermChange={setGlobalSearchTerm}
              stats={stats}
              isSilentRefresh={isSilentRefresh}
              onFilteredTicketsChange={setTableFilteredTickets}
              allFilterValues={filterValues}
              project={currentProject}
              sourcePhones={sourcePhones}
            />
          </TabsContent>



          {/* Onglet PARTIELS - vue dédiée attribution partielle */}
          <TabsContent value="partials" className="mt-0">
            <PartialAttributionsView
              project={currentProject}
              refreshKey={`${tickets.length}-${tickets.filter(t => t.type === 'VENTE' && t.attribution_status === 'partial').length}`}
              onComplete={async (vente) => {
                if (vente && vente.id) {
                  handleAttribuerVente(vente);
                } else {
                  await loadAllTickets();
                }
              }}
            />
          </TabsContent>

          {/* Onglet AUDIT QUOTA RG */}
          {isRolandGarros && (
            <TabsContent value="audit-quota" className="mt-0">
              <AuditQuotaView tickets={tickets} />
            </TabsContent>
          )}
        </Tabs>
      </main>

      {/* Modals */}
      <EmailImportModal
        open={showImportModal}
        onOpenChange={setShowImportModal}
        onImport={handleImport}
      />

      <TicketFormModal
        open={showFormModal}
        onOpenChange={setShowFormModal}
        ticket={editingTicket}
        onSave={handleSaveTicket}
        allTickets={tickets}
        project={currentProject}
        addedSources={addedSources}
        setAddedSources={setAddedSources}
      />

      <BulkImportModal
        open={showBulkImportModal}
        onOpenChange={setShowBulkImportModal}
        onImport={handleBulkImport}
      />

      <SmartImportModal
        open={showSmartImportModal}
        onOpenChange={setShowSmartImportModal}
        onImport={handleBulkImport}
        projectName={currentProject}
      />

      <GoogleSheetsImportModal
        open={showGoogleSheetsModal}
        onOpenChange={setShowGoogleSheetsModal}
        onImportComplete={fetchData}
        project={currentProject}
      />

      <InboxModal
        open={showInboxModal}
        onOpenChange={setShowInboxModal}
        onRefreshData={fetchData}
      />

      <DoublonsModal
        open={showDoublonsModal}
        onOpenChange={setShowDoublonsModal}
        currentProject={currentProject}
        onRefreshData={fetchData}
      />

      <EmailUpdateModal
        open={showEmailUpdateModal}
        onOpenChange={setShowEmailUpdateModal}
        project={currentProject}
        onRefreshData={fetchData}
      />

      <BulkValidateModal
        isOpen={showBulkValidateModal}
        onClose={() => setShowBulkValidateModal(false)}
        onSuccess={fetchData}
        project={currentProject}
      />

      <AiMatchModal
        isOpen={showAiMatchModal}
        onClose={() => setShowAiMatchModal(false)}
        onSuccess={fetchData}
        project={currentProject}
      />

      <AiAssistantWidget project={currentProject} />

      <AuditLivraisonsModal
        isOpen={showAuditLivraisonsModal}
        onClose={() => setShowAuditLivraisonsModal(false)}
        onSuccess={fetchData}
        project={currentProject}
      />

      <UpdatePlacementModal
        isOpen={showUpdatePlacementModal}
        onClose={() => setShowUpdatePlacementModal(false)}
        onSuccess={fetchData}
        project={currentProject}
      />

      <MatcherFilterModal
        isOpen={showMatcherFilterModal}
        onClose={() => setShowMatcherFilterModal(false)}
        onConfirm={handleRunMatchingFiltered}
        tickets={tickets}
        isLoading={matcherRunning}
      />

      <MajClientsModal
        open={showMajClientsModal}
        onOpenChange={setShowMajClientsModal}
        project={currentProject}
        onSuccess={fetchData}
      />

      <NormalizationModal
        open={showNormalizationModal}
        onOpenChange={setShowNormalizationModal}
        project={currentProject}
        onApplied={fetchData}
      />

      <BulkSeatUpdateModal
        open={showBulkSeatModal}
        onOpenChange={setShowBulkSeatModal}
        project={currentProject}
        onUpdated={fetchData}
      />

      <SourcePhonesModal
        open={showSourcePhonesModal}
        onOpenChange={setShowSourcePhonesModal}
        onSaved={loadSourcePhones}
        project={currentProject}
      />

      <DuplicateWarningModal
        open={!!duplicateData}
        duplicateData={duplicateData}
        onForceImport={handleForceImport}
        onImportWithout={handleImportWithoutDuplicates}
        onCancel={handleCancelDuplicateImport}
      />

      <AntiSingleModal
        isOpen={showAntiSingleModal}
        onClose={() => setShowAntiSingleModal(false)}
        onSuccess={fetchData}
      />

      <AttribuerVenteModal
        open={showAttribuerVenteModal}
        onOpenChange={setShowAttribuerVenteModal}
        venteTicket={selectedVenteForAttribution}
        project={currentProject}
        onSuccess={fetchData}
        onSpecialAttribution={handleSpecialAttribution}
      />

      <SpecialAttributionModal
        open={showSpecialAttributionModal}
        onOpenChange={setShowSpecialAttributionModal}
        venteTicket={selectedVenteForAttribution}
        project={currentProject}
        onSuccess={fetchData}
      />

      <RefCheckModal
        open={showRefCheckModal}
        onOpenChange={setShowRefCheckModal}
        currentProject={currentProject}
      />

      {/* Proof Upload Modal */}
      <ProofUploadModal
        isOpen={showProofModal}
        onClose={() => {
          setShowProofModal(false);
          setProofTicket(null);
        }}
        ticket={proofTicket}
        onProofUploaded={(ticketId, proofUrl) => {
          // Update local state to reflect the proof
          setTickets(prev => prev.map(t => 
            t.id === ticketId ? { ...t, preuve_url: proofUrl } : t
          ));
        }}
      />

      {/* Proof Envoi Modal (for ACHAT tickets) */}
      <ProofEnvoiModal
        isOpen={showProofEnvoiModal}
        onClose={() => {
          setShowProofEnvoiModal(false);
          setProofEnvoiTicket(null);
        }}
        ticket={proofEnvoiTicket}
        onProofUpdated={(ticketId, preuveEnvoiUrl, type) => {
          // Update local state to reflect the proof envoi
          setTickets(prev => prev.map(t => 
            t.id === ticketId ? { ...t, preuve_envoi: preuveEnvoiUrl } : t
          ));
        }}
      />

      {/* Confirmation Dialog - Désattribuer Tout */}
      {showDesattribuerConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <div className="bg-[#1a1a1a] border border-red-500/50 rounded-lg p-6 max-w-md mx-4 shadow-xl">
            <div className="flex items-center gap-2 mb-4">
              <AlertTriangle className="h-8 w-8 text-red-500" />
              <h3 className="text-xl font-bold text-white">ATTENTION</h3>
            </div>
            
            <p className="text-white text-lg mb-4">
              Vous allez <span className="text-red-400 font-bold">TOUT DÉSATTRIBUER</span>.
            </p>
            <p className="text-zinc-400 mb-2">
              Cette action va :
            </p>
            <ul className="text-zinc-300 text-sm mb-4 list-disc list-inside space-y-1">
              <li>Retirer les attributions de <strong>TOUS</strong> les billets ACHAT</li>
              <li>Effacer ref_vente, nom_client, mail_client</li>
              <li>Remettre le statut des VENTE à vide</li>
            </ul>
            <p className="text-emerald-400 text-sm mb-6">
              ✓ Un snapshot sera créé pour pouvoir revenir en arrière
            </p>
            
            <p className="text-white font-medium mb-4">Êtes-vous sûr ?</p>
            
            <div className="flex gap-3">
              <Button 
                onClick={() => setShowDesattribuerConfirm(false)}
                variant="outline"
                className="flex-1 border-zinc-600"
              >
                NON, Annuler
              </Button>
              <Button 
                onClick={confirmDesattribuerAll}
                className="flex-1 bg-red-600 hover:bg-red-500 text-white"
              >
                OUI, Désattribuer tout
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* System Health Modal — état serveur en temps réel */}
      <SystemHealthModal open={showSystemHealth} onClose={() => setShowSystemHealth(false)} />

      {/* History Modal - Restauration */}
      {showHistoryModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <div className="bg-[#1a1a1a] border border-[#C4A052]/50 rounded-lg p-6 max-w-lg mx-4 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <History className="h-6 w-6 text-[#C4A052]" />
                <h3 className="text-xl font-bold text-white">Historique des versions</h3>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowHistoryModal(false)}
                className="text-zinc-400 hover:text-white h-8 w-8 p-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
            
            <p className="text-zinc-400 text-sm mb-4">
              Restaurez une version antérieure de vos données.
              <span className="text-amber-400"> Attention : les données actuelles seront remplacées.</span>
            </p>
            
            {loadingSnapshots ? (
              <div className="flex items-center justify-center py-8">
                <RefreshCw className="h-6 w-6 animate-spin text-[#C4A052]" />
              </div>
            ) : snapshots.length === 0 ? (
              <div className="text-center py-8 text-zinc-500">
                <History className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p>Aucun snapshot disponible</p>
                <p className="text-xs mt-1">Les snapshots sont créés automatiquement lors d'actions importantes</p>
              </div>
            ) : (
              <div className="space-y-2 max-h-80 overflow-y-auto">
                {snapshots.map((snap, idx) => {
                  const date = new Date(snap.created_at);
                  const now = new Date();
                  const diffMs = now - date;
                  const diffMins = Math.floor(diffMs / 60000);
                  const diffHours = Math.floor(diffMs / 3600000);
                  const diffDays = Math.floor(diffMs / 86400000);
                  
                  let timeAgo = '';
                  if (diffMins < 60) timeAgo = `${diffMins} min`;
                  else if (diffHours < 24) timeAgo = `${diffHours}h`;
                  else timeAgo = `${diffDays} jour(s)`;
                  
                  return (
                    <div 
                      key={snap.id}
                      className="p-3 rounded-lg bg-zinc-800/50 border border-zinc-700 hover:border-[#C4A052]/50 transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-white font-medium">{snap.reason}</p>
                          <p className="text-xs text-zinc-400">
                            {date.toLocaleString('fr-FR')} • {timeAgo} • {snap.ticket_count} tickets
                          </p>
                        </div>
                        <Button
                          onClick={() => handleRestoreSnapshot(snap.id)}
                          size="sm"
                          className="bg-[#C4A052] hover:bg-[#D4B86A] text-black"
                        >
                          <RotateCcw className="h-4 w-4 mr-1" />
                          Restaurer
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            
            <Button 
              onClick={() => setShowHistoryModal(false)}
              variant="outline" 
              className="w-full mt-4 border-zinc-700"
            >
              Fermer
            </Button>
          </div>
        </div>
      )}

      {/* Modal de confirmation changement de projet */}
      {showProjectChangeConfirm && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div className="bg-zinc-900 border border-[#C4A052]/30 rounded-xl p-6 max-w-md w-full mx-4 shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-full bg-amber-500/20">
                <AlertCircle className="h-6 w-6 text-amber-500" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Changer de projet ?</h3>
                <p className="text-zinc-400 text-sm">Cette action va charger un autre projet</p>
              </div>
            </div>
            
            <div className="bg-zinc-800 rounded-lg p-4 mb-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-zinc-400 text-xs">Projet actuel</p>
                  <p className="text-white font-medium">{currentProject}</p>
                </div>
                <ArrowRight className="h-5 w-5 text-[#C4A052]" />
                <div className="text-right">
                  <p className="text-zinc-400 text-xs">Nouveau projet</p>
                  <p className="text-[#C4A052] font-bold">{pendingProjectChange}</p>
                </div>
              </div>
            </div>
            
            <p className="text-zinc-400 text-sm mb-4">
              Toutes les données affichées seront remplacées par celles du projet <span className="text-[#C4A052] font-semibold">{pendingProjectChange}</span>.
            </p>
            
            <div className="flex gap-3">
              <Button
                onClick={cancelProjectChange}
                variant="outline"
                className="flex-1 border-zinc-600"
              >
                Annuler
              </Button>
              <Button
                onClick={confirmProjectChange}
                className="flex-1 bg-[#C4A052] hover:bg-[#D4B86A] text-black font-bold"
              >
                Confirmer
              </Button>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

// Wrap App with ErrorBoundary to catch all errors
const AppWithErrorBoundary = () => (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

export default AppWithErrorBoundary;
;
